<template>
  <div  class="product imgTOP-current header-90">
      <div  class="top-img">
        <img class="mobile_hide" src="../assets/images/product-banner.png" alt="">
        <div class="info-box">
          <div class="title-box">
            <h2>{{nameEN}}</h2>
            <h3 v-if="$i18n.locale!='en'">{{name}}</h3>
          </div>
         <!-- <div class="bannerImage">
            <img :src="bannerImage" alt="">
          </div>-->
        </div>
      </div>
    <div class="product-main">
      <div class="product-conten">
        <div class="product-title">
          <router-link to="/home">{{$t("home_0")}}</router-link>
          <em>/</em>
          <span>{{name}}</span>
        </div>
        <div class="nav mobile_hide">
          <h4  :class="{'en-font-28':locale=='EN'}">{{$t('home_00')}}</h4>
          <ul>
            <li v-for="(item,index) in typeList" :key="index" @click="tabtitle(item.id, item.name, item.bannerImage)" :class="{ active: paramId == item.id }" class="box">
              <a :class="{'en-font-18':locale=='EN'}">{{item.name}}</a><em class="nav-line"></em>
            </li>
          </ul>
        </div>
        <div class="type-nav pc_hide" v-if="typeList.length > 0">
          <vue-tab-select v-model="paramId" :list="typeList" :title="'home_00'" :keyName="'id'" @valueChanged="changeType"></vue-tab-select>
        </div>

        <div class="product-show">


          <ul>
            <span v-if="this.name =='財務資訊'||this.name =='Financials'||this.name =='财务信息'">
              <div class="investor-nav mobile_hide" :class="{'en-nav-font':locale=='EN'}">
            <ul>
              <li @click="linktop('top13')" :class="[{active : refname2=='top13'}]">{{$t("investor_21")}}</li>
              <li @click="linktop('top14')" :class="[{active : refname2=='top14'}]">{{$t("investor_22")}}</li>
              <li @click="linktop('top15')" :class="[{active : refname2=='top15'}]">{{$t("investor_23")}}</li>
            </ul>
          </div>
          <div class="type-nav pc_hide">
            <vue-tab-select v-model="refname2" v-bind:list="menuList2" v-bind:title="'company_6'" v-on:valueChanged="linktop"></vue-tab-select>
          </div>
          <div ref="top13" id="top13" class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_21")}}</h3>
      <br />
      <b>
        {{$t("investor_456")}}
					</b>
          <!-- <select id="yearSearch" name="yearSearch" onchange="myFunction()" class="form-select"> -->
            <select v-model="yearSearch"  class="form-select" id="yearSearch" name="yearSearch" style="width:80px;">
            <option value="2025">2025</option>
            <option value="2024">2024</option>
						<option value="2023">2023</option>
						<option value="2022">2022</option>
						<option value="2021">2021</option>
						<option value="2020">2020</option>
						<option value="2019">2019</option>
					</select>
					<hr style="visibility:hidden" />

					<p>{{$t("investor_457")}}</p>
<table v-show="selectedYear === '2025'" style="width:100%;" class="table table-bordered"> <!--2025年度-->

<tr>
  <td rowspan="2" width="115">2025</td>
  <td colspan="2" width="230">{{$t("investor_458")}}</td>
</tr>
<tr>
  <td width="115">{{$t("investor_459")}}</td>
  <td width="115">{{$t("investor_460")}}</td>
</tr>
<tr>  <!--1月-->
  <td width="115">{{$t("investor_461")}}</td>
  <td width="115" class="tb-txt">715,856</td>
  <td width="115" class="tb-txt">4.75%</td>
</tr>
<tr><!--2月-->
  <td width="115">{{$t("investor_462")}}</td>
  <td width="115" class="tb-txt">703,320</td>
  <td width="115" class="tb-txt">19.24%</td>
</tr>
<tr><!--3月-->
  <td width="115">{{$t("investor_463")}}</td>
  <td width="115" class="tb-txt">758,173</td>
  <td width="115" class="tb-txt">15.90%</td>
</tr>
<tr><!--4月-->
  <td width="115">{{$t("investor_464")}}</td>
  <td width="115" class="tb-txt">705,278</td>
  <td width="115" class="tb-txt">15.54%</td>
</tr>
<tr><!--5月-->
  <td width="115">{{$t("investor_465")}}</td>
  <td width="115" class="tb-txt">706,117</td>
  <td width="115" class="tb-txt">8.35%</td>
</tr>
<tr><!--6月-->
  <td width="115">{{$t("investor_466")}}</td>
  <td width="115" class="tb-txt">696,372</td>
  <td width="115" class="tb-txt">6.81%</td>
</tr>
<tr><!--7月-->
  <td width="115">{{$t("investor_467")}}</td>
  <td width="115" class="tb-txt">730,407</td>
  <td width="115" class="tb-txt">6.18%</td>
</tr>
<tr><!--8月-->
  <td width="115">{{$t("investor_468")}}</td>
  <td width="115" class="tb-txt">750,693</td>
  <td width="115" class="tb-txt">8.67%</td>
</tr>
<tr><!--9月-->
  <td width="115">{{$t("investor_469")}}</td>
  <td width="115" class="tb-txt">721,329</td>
  <td width="115" class="tb-txt">7.36%</td>
</tr>
<tr><!--10月-->
  <td width="115">{{$t("investor_470")}}</td>
  <td width="115" class="tb-txt">766,234</td>
  <td width="115" class="tb-txt">8.62%</td>
</tr>
<tr><!--11月-->
  <td width="115">{{$t("investor_471")}}</td>
  <td width="115" class="tb-txt">-</td>
  <td width="115" class="tb-txt">-</td>
</tr>
<tr><!--12月-->
  <td width="115">{{$t("investor_472")}}</td>
  <td width="115" class="tb-txt">-</td>
  <td width="115" class="tb-txt">-</td>
</tr>
<tr><!--2025總計-->
  <td width="115">{{$t("investor_473")}}</td>
  <td width="115" class="tb-txt">7,253,779</td>
  <td width="115" class="tb-txt">9.95%</td>
</tr>
</table>




	<!-- <table id="2024" style="width:100%;" class="table table-bordered" cellspacing="0" cellpadding="0"> -->
    <table v-show="selectedYear === '2024'" style="width:100%;" class="table table-bordered"> <!--2024年度-->

<tr>
  <td rowspan="2" width="115">2024</td>
  <td colspan="2" width="230">{{$t("investor_458")}}</td>
</tr>
<tr>
  <td width="115">{{$t("investor_459")}}</td>
  <td width="115">{{$t("investor_460")}}</td>
</tr>
<tr>
  <td width="115">{{$t("investor_461")}}</td>
  <td width="115" class="tb-txt">683,379</td>
  <td width="115" class="tb-txt">18.06%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_462")}}</td>
  <td width="115" class="tb-txt">589,840</td>
  <td width="115" class="tb-txt">7.34%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_463")}}</td>
  <td width="115" class="tb-txt">654,188</td>
  <td width="115" class="tb-txt">9.43%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_464")}}</td>
  <td width="115" class="tb-txt">610,424</td>
  <td width="115" class="tb-txt">6.60%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_465")}}</td>
  <td width="115" class="tb-txt">651,705</td>
  <td width="115" class="tb-txt">6.76%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_466")}}</td>
  <td width="115" class="tb-txt">651,990</td>
  <td width="115" class="tb-txt">10.75%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_467")}}</td>
  <td width="115" class="tb-txt">687,904</td>
  <td width="115" class="tb-txt">7.50%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_468")}}</td>
  <td width="115" class="tb-txt">690,783</td>
  <td width="115" class="tb-txt">3.08%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_469")}}</td>
  <td width="115" class="tb-txt">671,862</td>
  <td width="115" class="tb-txt">9.22%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_470")}}</td>
  <td width="115" class="tb-txt">705,435</td>
  <td width="115" class="tb-txt">7.49%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_471")}}</td>
  <td width="115" class="tb-txt">687,739</td>
  <td width="115" class="tb-txt">10.63%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_472")}}</td>
  <td width="115" class="tb-txt">742,738</td>
  <td width="115" class="tb-txt">16.27%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_473")}}</td>
  <td width="115" class="tb-txt">8,027,985</td>
  <td width="115" class="tb-txt">9.37%</td>
</tr>
</table>

          <!-- <table id="2023" style="width:100%;" class="table table-bordered" cellspacing="0" cellpadding="0"> -->
        <table v-show="selectedYear === '2023'" style="width:100%;" class="table table-bordered"> <!--2023年度-->

<tr>
  <td rowspan="2" width="115">2023</td>
  <td colspan="2" width="230">{{$t("investor_458")}}</td>
</tr>
<tr>
  <td width="115">{{$t("investor_459")}}</td>
  <td width="115">{{$t("investor_460")}}</td>
</tr>
<tr>
  <td width="115">{{$t("investor_461")}}</td>
  <td width="115" class="tb-txt">578,820</td>
  <td width="115" class="tb-txt">6.08%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_462")}}</td>
  <td width="115" class="tb-txt">549,525</td>
  <td width="115" class="tb-txt">17.43%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_463")}}</td>
  <td width="115" class="tb-txt">597,826</td>
  <td width="115" class="tb-txt">9.83%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_464")}}</td>
  <td width="115" class="tb-txt">572,633</td>
  <td width="115" class="tb-txt">4.77%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_465")}}</td>
  <td width="115" class="tb-txt">610,439</td>
  <td width="115" class="tb-txt">4.05%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_466")}}</td>
  <td width="115" class="tb-txt">588,702</td>
  <td width="115" class="tb-txt">4.89%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_467")}}</td>
  <td width="115" class="tb-txt">639,927</td>
  <td width="115" class="tb-txt">8.21%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_468")}}</td>
  <td width="115" class="tb-txt">670,145</td>
  <td width="115" class="tb-txt">12.82%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_469")}}</td>
  <td width="115" class="tb-txt">615,167</td>
  <td width="115" class="tb-txt">4.11%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_470")}}</td>
  <td width="115" class="tb-txt">656,274</td>
  <td width="115" class="tb-txt">7.76%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_471")}}</td>
  <td width="115" class="tb-txt">621,649</td>
  <td width="115" class="tb-txt">7.46%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_472")}}</td>
  <td width="115" class="tb-txt">638,782</td>
  <td width="115" class="tb-txt">9.56%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_473")}}</td>
  <td width="115" class="tb-txt">7,339,890</td>
  <td width="115" class="tb-txt">7.95%</td>
</tr>
</table>
<!-- <table id="2022" style="width:100%;display:none;" class="table table-bordered" cellspacing="0" cellpadding="0"> -->
  <table v-show="selectedYear === '2022'" style="width:100%;" class="table table-bordered">    <!--2022年度-->
<tr>
  <td rowspan="2" width="115">2022</td>
  <td colspan="2" width="230">{{$t("investor_458")}}</td>
</tr>
<tr>
  <td width="115">{{$t("investor_459")}}</td>
  <td width="115">{{$t("investor_460")}}</td>
</tr>
<tr>
  <td width="115">{{$t("investor_461")}}</td>
  <td width="115" class="tb-txt">545,635</td>
  <td width="115" class="tb-txt">10.54%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_462")}}</td>
  <td width="115" class="tb-txt">467,968</td>
  <td width="115" class="tb-txt">11.33%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_463")}}</td>
  <td width="115" class="tb-txt">544,322</td>
  <td width="115" class="tb-txt">9.17%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_464")}}</td>
  <td width="115" class="tb-txt">546,568</td>
  <td width="115" class="tb-txt">13.07%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_465")}}</td>
  <td width="115" class="tb-txt">586,698</td>
  <td width="115" class="tb-txt">13.01%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_466")}}</td>
  <td width="115" class="tb-txt">561,265</td>
  <td width="115" class="tb-txt">24.80%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_467")}}</td>
  <td width="115" class="tb-txt">591,395</td>
  <td width="115" class="tb-txt">21.41%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_468")}}</td>
  <td width="115" class="tb-txt">593,994</td>
  <td width="115" class="tb-txt">16.20%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_469")}}</td>
  <td width="115" class="tb-txt">590,866</td>
  <td width="115" class="tb-txt">17.01%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_470")}}</td>
  <td width="115" class="tb-txt">609,002</td>
  <td width="115" class="tb-txt">13.90%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_471")}}</td>
  <td width="115" class="tb-txt">578,506</td>
  <td width="115" class="tb-txt">12.04%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_472")}}</td>
  <td width="115" class="tb-txt">582,969</td>
  <td width="115" class="tb-txt">8.76%</td>
</tr>
<tr>
  <td width="115">{{$t("investor_473")}}</td>
  <td width="115" class="tb-txt">6,799,187</td>
  <td width="115" class="tb-txt">14.17%</td>
</tr>
</table>
<table v-show="selectedYear === '2021'" style="width:100%;" class="table table-bordered">    <!--2021年度-->
  <tr>
							<td rowspan="2" width="115">2021</td>
							<td colspan="2" width="230">{{$t("investor_458")}}</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_459")}}</td>
							<td width="115">{{$t("investor_460")}}</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_461")}}</td>
							<td width="115" class="tb-txt">493,617</td>
							<td width="115" class="tb-txt">21.57%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_462")}}</td>
							<td width="115" class="tb-txt">420,353</td>
							<td width="115" class="tb-txt">6.99%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_463")}}</td>
							<td width="115" class="tb-txt">498,583</td>
							<td width="115" class="tb-txt">21.33%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_464")}}</td>
							<td width="115" class="tb-txt">483,391</td>
							<td width="115" class="tb-txt">23.41%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_465")}}</td>
							<td width="115" class="tb-txt">519,176</td>
							<td width="115" class="tb-txt">23.60%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_466")}}</td>
							<td width="115" class="tb-txt">449,748</td>
							<td width="115" class="tb-txt">8.85%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_467")}}</td>
							<td width="115" class="tb-txt">487,091</td>
							<td width="115" class="tb-txt">8.73%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_468")}}</td>
							<td width="115" class="tb-txt">511,187</td>
							<td width="115" class="tb-txt">15.76%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_469")}}</td>
							<td width="115" class="tb-txt">504,955</td>
							<td width="115" class="tb-txt">16.54%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_470")}}</td>
							<td width="115" class="tb-txt">534,665</td>
							<td width="115" class="tb-txt">16.07%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_471")}}</td>
							<td width="115" class="tb-txt">516,333</td>
							<td width="115" class="tb-txt">6.34%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_472")}}</td>
							<td width="115" class="tb-txt">536,020</td>
							<td width="115" class="tb-txt">11.61%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_473")}}</td>
							<td width="115" class="tb-txt">5,955,120</td>
							<td width="115" class="tb-txt">14.87%</td>
						</tr>
</table>
<table v-show="selectedYear === '2020'" style="width:100%;" class="table table-bordered">    <!--2020年度-->
  <tr>
							<td rowspan="2" width="115">2020</td>
							<td colspan="2" width="230">{{$t("investor_458")}}</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_459")}}</td>
							<td width="115">{{$t("investor_460")}}</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_461")}}</td>
							<td width="115" class="tb-txt">406,021</td>
							<td width="115" class="tb-txt">-0.01%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_462")}}</td>
							<td width="115" class="tb-txt">392,872</td>
							<td width="115" class="tb-txt">22.42%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_463")}}</td>
							<td width="115" class="tb-txt">410,930</td>
							<td width="115" class="tb-txt">0.99%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_464")}}</td>
							<td width="115" class="tb-txt">391,694</td>
							<td width="115" class="tb-txt">1.04%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_465")}}</td>
							<td width="115" class="tb-txt">420,041</td>
							<td width="115" class="tb-txt">2.91%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_466")}}</td>
							<td width="115" class="tb-txt">413,182</td>
							<td width="115" class="tb-txt">3.56%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_467")}}</td>
							<td width="115" class="tb-txt">447,980</td>
							<td width="115" class="tb-txt">6.00%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_468")}}</td>
							<td width="115" class="tb-txt">441,602</td>
							<td width="115" class="tb-txt">4.69%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_469")}}</td>
							<td width="115" class="tb-txt">433,274</td>
							<td width="115" class="tb-txt">7.42%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_470")}}</td>
							<td width="115" class="tb-txt">460,625</td>
							<td width="115" class="tb-txt">8.52%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_471")}}</td>
							<td width="115" class="tb-txt">485,548</td>
							<td width="115" class="tb-txt">17.86%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_472")}}</td>
							<td width="115" class="tb-txt">480,265</td>
							<td width="115" class="tb-txt">14.41%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_473")}}</td>
							<td width="115" class="tb-txt">5,184,034</td>
							<td width="115" class="tb-txt">7.27%</td>
						</tr>
</table>
<table v-show="selectedYear === '2019'" style="width:100%;" class="table table-bordered">    <!--2019年度-->
  <tr>
							<td rowspan="2" width="115">2019</td>
							<td colspan="2" width="230">{{$t("investor_458")}}</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_459")}}</td>
							<td width="115">{{$t("investor_460")}}</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_461")}}</td>
							<td width="115" class="tb-txt">406,057</td>
							<td width="115" class="tb-txt">7.38%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_462")}}</td>
							<td width="115" class="tb-txt">320,923</td>
							<td width="115" class="tb-txt">2.91%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_463")}}</td>
							<td width="115" class="tb-txt">406,918</td>
							<td width="115" class="tb-txt">6.70%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_464")}}</td>
							<td width="115" class="tb-txt">387,681</td>
							<td width="115" class="tb-txt">7.68%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_465")}}</td>
							<td width="115" class="tb-txt">408,151</td>
							<td width="115" class="tb-txt">8.07%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_466")}}</td>
							<td width="115" class="tb-txt">398,980</td>
							<td width="115" class="tb-txt">11.03%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_467")}}</td>
							<td width="115" class="tb-txt">422,634</td>
							<td width="115" class="tb-txt">9.26%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_468")}}</td>
							<td width="115" class="tb-txt">421,831</td>
							<td width="115" class="tb-txt">10.50%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_469")}}</td>
							<td width="115" class="tb-txt">403,329</td>
							<td width="115" class="tb-txt">10.14%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_470")}}</td>
							<td width="115" class="tb-txt">424,442</td>
							<td width="115" class="tb-txt">7.54%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_471")}}</td>
							<td width="115" class="tb-txt">411,974</td>
							<td width="115" class="tb-txt">7.88%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_472")}}</td>
							<td width="115" class="tb-txt">419,780</td>
							<td width="115" class="tb-txt">9.36%</td>
						</tr>
						<tr>
							<td width="115">{{$t("investor_473")}}</td>
							<td width="115" class="tb-txt">4,832,700</td>
							<td width="115" class="tb-txt">8.27%</td>
						</tr>
</table>
			</div>
              </div></div></div>
              <div ref="top14" id="top14" class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_22")}}</h3>
      <br />
      <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
        <p><a  href="../../static/files/2025Q2 Consolidated Financial Report.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2025Q2 Consolidated Financial Report.pdf</a></p>
        <p><a  href="../../static/files/2025Q1 Consolidated Financial Report.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2025Q1 Consolidated Financial Report.pdf</a></p>
        <p><a  href="../../static/files/2024 Stand-alone Financial Report.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2024 Stand-alone Financial Report.pdf</a></p>
        <p><a  href="../../static/files/2024 Consolidated Financial Report.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2024 Consolidated Financial Report.pdf</a></p>
        <p><a  href="../../static/files/2024Q3 Consolidated Financial Report.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2024Q3 Consolidated Financial Report</a></p>
        <p><a  href="../../static/files/2024Q2 Consolidated Financial Report.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2024Q2 Consolidated Financial Report</a></p>
        <p><a  href="../../static/files/2024Q1 Consolidated Financial Report.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2024Q1 Consolidated Financial Report</a></p>
        <p><a  href="../../static/files/2023 Consolidated Financial Report.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2023 Consolidated Financial Report</a></p>
        <p><a  href="../../static/files/2023 Stand-alone Financial Report.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2023 Stand-alone Financial Report</a></p>
        <p><a  href="../../static/files/F2E-2023-3.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2023Q3 Consolidated Financial Report</a></p>
        <p><a  href="../../static/files/F2E-2023-2.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2023Q2 Consolidated Financial Report</a></p>
        <p><a  href="../../static/files/F2E-2023-1.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2023Q1 Consolidated Financial Report</a></p>
        <p><a  href="../../static/files/F2E-2022-22.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2022 Consolidated Financial Report</a></p>
        <p><a  href="../../static/files/F2E-2022-11.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2022 Stand-alone Financial Report</a></p>
        <p><a  href="../../static/files/F2E-2021-22.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2021 Consolidated Financial Report</a></p>
        <p><a  href="../../static/files/F2E-2021-11.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2021 Stand-alone Financial Report</a></p>
      </span>
      <span v-else>
      <table class="table" style="width:80%;">
					<tbody>
            <tr>
							<td>114年Q3合併財務報告</td>
							<td>
                <a href="../../static/files/114年Q3合併財務報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>            
            <tr>
							<td>114年Q2合併財務報告</td>
							<td>
                <a href="../../static/files/114年Q2合併財務報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
            <tr>
							<td>114年Q1合併財務報告</td>
							<td>
                <a href="../../static/files/114年Q1合併財務報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
            <tr>
							<td>113年度個體財務報告</td>
							<td>
                <a href="../../static/files/113年度個體財務報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>

            <tr>
							<td>113年度合併財務報告</td>
							<td>
                <a href="../../static/files/113年度合併財務報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>

            <tr>
							<td>113年Q3合併財務報告</td>
							<td>
                <a href="../../static/files/113年Q3合併財務報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>

            <tr>
							<td>113年Q2合併財務報告</td>
							<td>
                <a href="../../static/files/113年Q2合併財務報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
            <tr>
							<td>113年Q1合併財務報告</td>
							<td>
                <a href="../../static/files/113年Q1合併財務報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
          	<tr>
							<td>112年度合併財務報告</td>
							<td>
                <a href="../../static/files/112年度合併財務報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
            <tr>
							<td>112年度個體財務報告</td>
							<td><a href="../../static/files/112年度個體財務報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>112年Q3合併財務報告</td>
							<td>
                <a href="../../static/files/F2-112Q3.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>112年Q2合併財務報告</td>
							<td><a href="../../static/files/F2-112Q2.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>112年Q1合併財務報告</td>
							<td><a href="../../static/files/F2-112Q1.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>

						<tr>
							<td>111年度合併財務報告</td>
							<td><a href="../../static/files/F2-111-1.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>111年度個體財務報告</td>
							<td><a href="../../static/files/F2-111-2.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>111年Q3合併財務報告</td>
							<td><a href="../../static/files/F2-111Q3.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>111年Q2合併財務報告</td>
							<td><a href="../../static/files/F2-111Q2.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>111年Q1合併財務報告</td>
							<td><a href="../../static/files/F2-111Q1.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>110年度合併財務報告</td>
							<td><a href="../../static/files/F2-110-1.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>110年度個體財務報告</td>
							<td><a href="../../static/files/F2-110-2.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>110年Q3合併財務報告</td>
							<td><a href="../../static/files/F2-110Q3.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>110年Q2合併財務報告</td>
							<td><a href="../../static/files/F2-110Q2.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>110年Q1合併財務報告</td>
							<td><a href="../../static/files/F2-110Q1.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>109年Q2合併財務報告</td>
							<td><a href="../../static/files/F2-109Q2.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>109年度合併財務報告</td>
							<td><a href="../../static/files/F2-109-1.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
						<tr>
							<td>109年度個體財務報告</td>
							<td><a href="../../static/files/F2-109-2.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></td>
						</tr>
					</tbody>
				</table>
      </span>
			</div>
              </div></div></div>
              <div ref="top15" id="top15" class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_23")}}</h3>
      <br />
                  <p>
                    <a href="https://mopsov.twse.com.tw/mops/web/t163sb08?firstin=1&step=1&isnew=true&co_id=2753" target="_blank">{{$t("investor_492")}}</a>
                    <br><br>
                    <a href="https://mopsov.twse.com.tw/mops/web/t05st22_q1?firstin=1&step=1&isnew=true&co_id=2753" target="_blank">{{$t("investor_493")}}</a>
                    <br><br>
                    {{$t("investor_494")}}
                  </p>
			</div>
              </div></div></div>


            </span>

            <span v-if="this.name =='股東專區'||this.name =='Shareholder Service'||this.name =='股东专区'">
              <div class="investor-nav mobile_hide" :class="{'en-nav-font':locale=='EN'}">
            <ul>
              <li @click="linktop('top16')" :class="[{active : refname3=='top16'}]">{{$t("investor_24")}}</li>
              <li @click="linktop('top17')" :class="[{active : refname3=='top17'}]">{{$t("investor_25")}}</li>
              <li @click="linktop('top18')" :class="[{active : refname3=='top18'}]">{{$t("investor_26")}}</li>
              <li @click="linktop('top19')" :class="[{active : refname3=='top19'}]">{{$t("investor_27")}}</li>
              <li @click="linktop('top20')" :class="[{active : refname3=='top20'}]">{{$t("investor_28")}}</li>
            </ul>
          </div>
          <div class="type-nav pc_hide">
            <vue-tab-select v-model="refname3" v-bind:list="menuList3" v-bind:title="'company_6'" v-on:valueChanged="linktop"></vue-tab-select>
          </div>
          <div ref="top16" id="top16" class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_24")}}</h3>
      <br />
      <h4>{{$t("investor_495")}}</h4>
      <p>
        {{$t("investor_496")}}
        <table class="table table-bordered" border="1" style="width:100%;">
					<tr>

						<td>
							<p style="text-align:right;"></p>
							<p class="align-items-center">{{$t("investor_497")}}</p>
						</td>
						<td>
							{{$t("investor_498")}}
						</td>
						<td>
							{{$t("investor_499")}}
						</td>

					</tr>
					<tr>
						<td>{{$t("investor_500")}}</td>
						<td>
							11,209,966
						</td>
						<td>
							16.82%
						</td>
					</tr>

					<tr >
						<td>{{$t("investor_025")}}</td>
						<td>
							5,125,963
						</td>
						<td>
							7.69%
						</td>
					</tr>
					<tr>
						<td>{{$t("investor_501")}}</td>
						<td>
							4,572,784
						</td>
						<td>
							6.86%
						</td>
					</tr>
					<tr>
						<td>{{$t("investor_021")}}</td>
						<td>
							3,219,628
						</td>
						<td>
							4.83%
						</td>
					</tr>
					<tr>
						<td>{{$t("investor_502")}}</td>
						<td>
							3,186,988
						</td>
						<td>
							4.78%
						</td>
					</tr>
					<tr>
						<td>{{$t("investor_503")}}</td>
						<td>
							2,552,988
						</td>
						<td>
							3.83%
						</td>
					</tr>
					<tr>
						<td>{{$t("investor_504")}}</td>
						<td>
							2,314,000
						</td>
						<td>
							3.47%
						</td>
					</tr>
					<!-- <tr >
						<td>{{$t("investor_505")}}</td>
						<td>
							1,615,000
						</td>
						<td>
							2.43%
						</td>
					</tr> -->
					<tr>
						<td>
							{{$t("investor_506")}}
						</td>
						<td>
							941,340
						</td>
						<td>
							1.41%
						</td>
					</tr>
          <tr>
						<td>
							{{$t("investor_508-1")}}
						</td>
						<td>
							850,000
						</td>
						<td>
							1.28%
						</td>
					</tr>
					<tr>
						<td>
							{{$t("investor_507")}}
						</td>
						<td>
							758,492
						</td>
						<td>
							1.14%
						</td>
					</tr>
				</table>
      </p>


			</div>
              </div></div></div>
              <div ref="top17" id="top17" class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_25")}}</h3>
      <br />
      <h5>{{$t("investor_508")}}</h5>


        <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
                2025
                <p><a href= "../../static/files/S1E1141.pdf" target="_blank">Meeting Notice</a></p>
					      <p><a href= "../../static/files/S1E1142.pdf" target="_blank">Handbook</a></p>
                2024
                <p><a href= "../../static/files/S1E1131.pdf" target="_blank">Meeting Notice</a></p>
					  		<p><a href= "../../static/files/S1E1132.pdf" target="_blank">Handbook</a></p>
          {{$t("investor_509")}}

					  		<p><a href= "../../static/files/S1E1121.pdf" target="_blank">Meeting Notice</a></p>
					  		<p><a href= "../../static/files/S1E1122.pdf" target="_blank">Handbook</a></p>
				2022
					  		<p><a href= "../../static/files/S1E1111.pdf" target="_blank">Meeting Notice</a></p>
					  		<p><a href= "../../static/files/S1E1112.pdf" target="_blank">Handbook</a></p><br>
						<h4>Annual Report</h4>
                <p><a href="../../static/files/S1E113.pdf" target="_blank">2024</a></p>
                <p><a href="../../static/files/S1E112.pdf" target="_blank">2023</a></p>
							  <p><a href="../../static/files/S1E111.pdf" target="_blank">2022</a></p>
					  		<p><a href="../../static/files/S1E110.pdf" target="_blank">2021</a></p>
        </span>
      <span v-else>
        <div class="investor-nav">
           <br />{{$t("investor_608")}}
						<ul>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-114-1.pdf" target="_blank">{{$t("investor_512")}}</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-114-2.pdf" target="_blank">{{$t("investor_513")}}</a></li>
              <li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-114-議事錄.pdf" target="_blank">議事錄</a></li>
							<p><a href="https://www.youtube.com/watch?v=J50hFmuHtyg" target="_blank">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../assets/images/play-button-red-icon.svg" style="width:30px;height:30px">股東會影片</a></p>              
            </ul>
            <br />
          {{$t("investor_607")}}
						<ul>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-113-1.pdf" target="_blank">{{$t("investor_512")}}</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-113-股東常會議事手冊.pdf" target="_blank">{{$t("investor_513")}}</a></li>
              <li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-113-議事錄.pdf" target="_blank">議事錄</a></li>
							<p><a href="https://youtu.be/5zj5zDgO4tA" target="_blank">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../assets/images/play-button-red-icon.svg" style="width:30px;height:30px">股東會影片</a></p>
          </ul>
          <br />{{$t("investor_509")}}
						<ul>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-112-1.pdf" target="_blank">{{$t("investor_512")}}</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-112-2.pdf" target="_blank">{{$t("investor_513")}}</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-112-3.pdf" target="_blank">議事錄</a></li>
            </ul>
            <br />
            {{$t("investor_510")}}
						<ul>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-111-1.pdf" target="_blank">{{$t("investor_512")}}</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-111-2.pdf" target="_blank">{{$t("investor_513")}}</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-111-3.pdf" target="_blank">議事錄</a></li>
						</ul>
            <br />
            {{$t("investor_515")}}
						<ul>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-110-1.pdf" target="_blank">{{$t("investor_512")}}</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-110-2.pdf" target="_blank">{{$t("investor_513")}}</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-110-3.pdf" target="_blank">議事錄</a></li>
						</ul>
            <br />
            {{$t("investor_516")}}
						<ul>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-1.pdf" target="_blank">{{$t("investor_512")}}</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-2.pdf" target="_blank">{{$t("investor_513")}}</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-3.pdf" target="_blank">議事錄</a></li>
						</ul>
            <br />
            {{$t("investor_511")}}
						<ul>
              <li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-113.pdf" target="_blank">113年度</a></li>
              <li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-112.pdf" target="_blank">112年度</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-111.pdf" target="_blank">111年度</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-110.pdf" target="_blank">110年度</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-109.pdf" target="_blank">109年度</a></li>
							<li><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"><a href="../../static/files/S1-4.pdf" target="_blank">108年度</a></li>
						</ul>
          </div>
           </span>
            <br>
            <a href="https://mops.twse.com.tw/mops/web/t108sb16_q1" target="_blank">{{$t("investor_517")}}{{$t("investor_518")}}{{$t("investor_519")}}</a>



			</div>

              </div></div></div>
              <div ref="top18" id="top18" class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_26")}}</h3>
      <br /><p>{{$t("investor_544")}}</p>
      <p>{{$t("investor_545")}}</p>
      <p>{{$t("investor_546")}}</p>
      <p>{{$t("investor_547")}}</p>
                  <p>
                    <a href="https://mopsov.twse.com.tw/mops/web/t05st09_2?encodeURIComponent=1&step=1&firstin=1&off=1&keyword4=&code1=&TYPEK2=&checkbtn=&queryName=co_id&inpuType=co_id&TYPEK=all&isnew=false&co_id=2753&date1=114&date2=114&qryType=2" target="_blank">{{$t("investor_520-2")}}</a>   
                    <br>                 
                    <a href="https://mopsov.twse.com.tw/mops/web/t05st09_2?encodeURIComponent=1&step=1&firstin=1&off=1&keyword4=&code1=&TYPEK2=&checkbtn=&queryName=co_id&inpuType=co_id&TYPEK=all&isnew=false&co_id=2753&date1=113&date2=113&qryType=2" target="_blank">{{$t("investor_520-1")}}</a>
                    <br>
                    <a href="https://mopsov.twse.com.tw/mops/web/t05st09_2?encodeURIComponent=1&step=1&firstin=1&off=1&keyword4=&code1=&TYPEK2=&checkbtn=&queryName=co_id&inpuType=co_id&TYPEK=all&isnew=false&co_id=2753&date1=112&date2=112&qryType=2" target="_blank">{{$t("investor_520")}}</a>
                    <br>
                    <a href="https://mopsov.twse.com.tw/mops/web/t05st09_2?encodeURIComponent=1&step=1&firstin=1&off=1&keyword4=&code1=&TYPEK2=&checkbtn=&queryName=co_id&inpuType=co_id&TYPEK=all&isnew=false&co_id=2753&date1=111&date2=111&qryType=2" target="_blank">{{$t("investor_521")}}</a>
                    <br>
                    <a href="https://mopsov.twse.com.tw/mops/web/t05st09_2?encodeURIComponent=1&step=1&firstin=1&off=1&keyword4=&code1=&TYPEK2=&checkbtn=&queryName=co_id&inpuType=co_id&TYPEK=all&isnew=false&co_id=2753&date1=110&date2=110&qryType=2" target="_blank">{{$t("investor_522")}}</a>
                    <br>
                    <a href="https://mopsov.twse.com.tw/mops/web/t05st09_2?encodeURIComponent=1&step=1&firstin=1&off=1&keyword4=&code1=&TYPEK2=&checkbtn=&queryName=co_id&inpuType=co_id&TYPEK=all&isnew=false&co_id=2753&date1=109&date2=109&qryType=2" target="_blank">{{$t("investor_523")}}</a>
                    <br>
                  </p><br>
                  <p>{{$t("investor_524")}}</p>
                  <p>{{$t("investor_525")}}<a href="https://mopsov.twse.com.tw/mops/web/t05st09_2" target="_blank">{{$t("investor_526")}}</a>{{$t("investor_527")}}</p>
                  <p>{{$t("investor_528")}}</p>
			</div>
              </div></div></div>
              <div ref="top19" id="top19" class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_27")}}</h3>
      <br />
                  <p>
                <div class="table-responsive">
		              <table style="width:100%;" class="table table-bordered">
			            <tr class="itembg"><td>{{$t("investor_061")}}</td><td>{{$t("investor_0611")}}</td><td>{{$t("investor_0612")}}</td><td>{{$t("investor_0613")}}</td><td>{{$t("investor_0614")}}</td></tr>
                  <tr><td>{{$t("investor_5324")}}</td><td>2:30PM(GMT+8)</td><td>{{$t("investor_5325")}}</td><td><span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a href="../../static/files/20251219法說會簡報(英文).pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span> <span v-else><a href="../../static/files/20251219法說會簡報(中文).pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span></td><td><a href="https://www.youtube.com/watch?v=GTpNmXkmoX4" target="_blank"><b>{{$t("investor_0614")}}</b></a></td></tr>                  
                  <tr><td>{{$t("investor_5323")}}</td><td>2:30PM(GMT+8)</td><td>{{$t("investor_539")}}</td><td><span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a href="../../static/files/SQ5E.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span> <span v-else><a href="../../static/files/SQ5.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span></td><td><a href="https://youtu.be/HeqYFxtII8Y?si=mCy8gInI2sLRvA33" target="_blank"><b>{{$t("investor_0614")}}</b></a></td></tr>
                  <tr><td>{{$t("investor_5322")}}</td><td>2:00PM(GMT+8)</td><td>{{$t("investor_5382")}}</td><td><span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a href="../../static/files/SQ4E.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span> <span v-else><a href="../../static/files/SQ4.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span></td><td><a href="https://youtu.be/1Cp71mWSZ4w" target="_blank"><b>{{$t("investor_0614")}}</b></a></td></tr>
                  <tr><td>{{$t("investor_5321")}}</td><td>3:00PM(GMT+8)</td><td>{{$t("investor_5381")}}</td><td><span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a href="../../static/files/S3E-7.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span> <span v-else><a href="../../static/files/S3-7.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span></td><td><a href="https://youtu.be/bNB7BmRX15Q" target="_blank"><b>{{$t("investor_0614")}}</b></a></td></tr>
                  <tr><td>{{$t("investor_532")}}</td><td>3:15PM(GMT+8)</td><td>{{$t("investor_538")}}</td><td><span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a href="../../static/files/S3E-6.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span> <span v-else><a href="../../static/files/S3-6.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span></td><td></td></tr>
			            <tr><td>{{$t("investor_533")}}</td><td>2:30PM(GMT+8)</td><td>{{$t("investor_539")}}</td><td><span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a href="../../static/files/S3E-5.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span> <span v-else><a href="../../static/files/S3-5.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span></td><td><a href="https://youtu.be/tinLhh_mGZs" target="_blank"><b>{{$t("investor_0614")}}</b></a></td></tr>
			            <tr><td>{{$t("investor_534")}}</td><td>2:00PM(GMT+8)</td><td>{{$t("investor_540")}}</td><td><span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a href="../../static/files/S3E-4.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span> <span v-else><a href="../../static/files/S3-4.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span></td><td></td></tr>
			            <tr><td>{{$t("investor_535")}}</td><td>9:00AM(GMT+8)</td><td>{{$t("investor_541")}}</td><td><span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a href="../../static/files/S3E-3.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span> <span v-else><a href="../../static/files/S3-3.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span></td><td></td></tr>
			            <tr><td>{{$t("investor_536")}}</td><td>3:30PM(GMT+8)</td><td>{{$t("investor_542")}}</td><td><span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a href="../../static/files/S3E-2.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span> <span v-else><a href="../../static/files/S3-2.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span></td><td></td></tr>
			            <tr><td>{{$t("investor_537")}}</td><td>2:30PM(GMT+8)</td><td>{{$t("investor_543")}}</td><td><span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a href="../../static/files/S3E.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span> <span v-else><a href="../../static/files/S3.pdf" target="_blank"><b><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></b></a></span></td><td><a href="https://www.youtube.com/watch?v=QUvBboaKRGs" target="_blank"><b>{{$t("investor_0614")}}</b></a></td></tr>
		              </table>
                  </div>
                  </p>
			</div>
              </div></div></div>
              <div ref="top20" id="top20" class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_28")}}</h3>
      <br />
      <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
        <p><a href="https://emops.twse.com.tw/server-java/t58query?id=1&step=421&caption_id=000001&co_id=2753&year=2025&month=all&sdate=all&hselectBy=1" target="_blank">2025</a></p>
        <p>※ Above information is accepting from <a href="https://emops.twse.com.tw/server-java/t58query" target="_blank">MOPS</a> (Stock code:2753)</p>
      </span>
      <span v-else>
          <p><a href="https://mopsov.twse.com.tw/mops/web/t05st01?firstin=1&step=1&isnew=false&co_id=2753&year=114" target="_blank">114年</a></p>        
          <p><a href="https://mopsov.twse.com.tw/mops/web/t05st01?firstin=1&step=1&isnew=false&co_id=2753&year=113" target="_blank">113年</a></p>
					<p><a href="https://mopsov.twse.com.tw/mops/web/t05st01?firstin=1&step=1&isnew=false&co_id=2753&year=112" target="_blank">112年</a></p>
					<p><a href="https://mopsov.twse.com.tw/mops/web/t05st01?firstin=1&step=1&isnew=false&co_id=2753&year=111" target="_blank">111年</a></p>
					<p><a href="https://mopsov.twse.com.tw/mops/web/t05st01?firstin=1&step=1&isnew=false&co_id=2753&year=110" target="_blank">110年</a></p>
					<p><a href="https://mopsov.twse.com.tw/mops/web/t05st01?firstin=1&step=1&isnew=false&co_id=2753&year=109" target="_blank">109年</a></p>
          <p>*以上資訊連結公開資訊觀測站*</p>
        </span>

			</div>
              </div></div></div>
            </span>

            <span v-if="this.name =='公司治理'||this.name =='Corporate Governance'">
              <div class="investor-nav" :class="{'en-nav-font':locale=='EN'}">
            <ul>
              <li @click="linktop('top1')" :class="[{active : refname=='top1'}]">{{$t("investor_01")}}</li>
              <li @click="linktop('top2')" :class="[{active : refname=='top2'}]">{{$t("investor_02")}}</li>
              <li @click="linktop('top3')" :class="[{active : refname=='top3'}]">{{$t("investor_03")}}</li>
              <li @click="linktop('top4')" :class="[{active : refname=='top4'}]">{{$t("investor_04")}}</li>
              <li @click="linktop('top5')" :class="[{active : refname=='top5'}]">{{$t("investor_05")}}</li>
              <li @click="linktop('top6')" :class="[{active : refname=='top6'}]">{{$t("investor_06")}}</li>
              <li @click="linktop('top7')" :class="[{active : refname=='top7'}]">{{$t("investor_07")}}</li>
              <li @click="linktop('top8')" :class="[{active : refname=='top8'}]">{{$t("investor_08")}}</li>
              <li @click="linktop('top9')" :class="[{active : refname=='top9'}]">{{$t("investor_09")}}</li>
              <li @click="linktop('top10')" :class="[{active : refname=='top10'}]">{{$t("investor_10")}}</li>
              <li @click="linktop('top11')" :class="[{active : refname=='top11'}]">{{$t("investor_11")}}</li> <!--防範內線***-->
              <li @click="linktop('top21')" :class="[{active : refname=='top21'}]">{{$t("investor_13")}}</li> <!--智慧財產管理-->
              <li @click="linktop('top12')" :class="[{active : refname=='top12'}]">{{$t("investor_12")}}</li> <!--資訊安全-->              
              <li @click="linktop('top22')" :class="[{active : refname=='top22'}]">{{$t("investor_14")}}</li> <!--個人資料保護-->

            </ul>
          </div>

          <div ref="top1" id="top1" class="about-box-01">      <!--組織架構 -->
          <div class="left">
              <div class="titleBox">
            <div class="description ">
              <h3>{{$t("investor_01")}}</h3>
              <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
                <img src="../assets/images/OrganizationC250107EN.jpg"  width="100%" height="100%"/>
                </span><span v-else>
              <img src="../assets/images/250529TW.jpg"  width="100%" height="100%"/>
            </span>
            </div></div>

            </div></div>
          <div ref="top2" id="top2" class="about-box-01">      <!--董事會 -->
          <div class="left">
              <div class="titleBox">
            <div class="description ">
              <h3>{{$t("investor_02")}}</h3>
              <p>{{$t("investor_601")}}</p>
              <p>{{$t("investor_602")}}</p>
              <p>{{$t("investor_603")}}</p>
              <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
                <img src="../assets/images/member250107EN.jpg" class="img01" width="100%" height="100%"/>
                </span><span v-else>
              <img src="../assets/images/member250107TW.jpg" class="img01" width="100%" height="100%"/>
              <p>{{$t("investor_001_1")}}</p>
            </span><br>
              <h3>{{$t("investor_001")}}</h3>
						<p>
              　　{{$t("investor_002")}}<br />
              　　{{$t("investor_003")}}
						</p>
            <div class="table-responsive">
            <table class="table table-bordered" border="1" style="width:100%;" >
							<tr>
								<td rowspan="2">{{$t("investor_004")}}</td>
								<td rowspan="2">{{$t("investor_005")}}</td>
								<td rowspan="2">{{$t("investor_006")}}</td>
								<td rowspan="2">{{$t("investor_007")}}</td>
								<td rowspan="2">{{$t("investor_008")}}</td>
								<td rowspan="2">{{$t("investor_009")}}</td>
								<td rowspan="2">{{$t("investor_010")}}</td>
								<td colspan="8">{{$t("investor_011")}}</td>
							</tr>
							<tr>
								<td>{{$t("investor_012")}}</td>
								<td>{{$t("investor_013")}}</td>
								<td>{{$t("investor_014")}}</td>
								<td>{{$t("investor_015")}}</td>
								<td>{{$t("investor_016")}}</td>
								<td>{{$t("investor_017")}}</td>
								<td>{{$t("investor_018")}}</td>
								<td>{{$t("investor_019")}}</td>
							</tr>
							<tr>  <!-- 一個tr代表一個人 林欣怡-->
								<td>{{$t("investor_020")}}</td>
								<td>{{$t("investor_021")}}</td>
								<td>{{$t("investor_022")}}</td>
								<td>{{$t("investor_023")}}</td>
								<td>41~50</td>
								<td>V</td>
								<td><p align="center">-</p></td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
							</tr>
              <tr>   <!-- 一個tr代表一個人 林明哲-->
								<td>{{$t("investor_610")}}</td>
								<td>{{$t("investor_611")}}</td>
								<td>{{$t("investor_022")}}</td>
								<td>{{$t("investor_026")}}</td>
								<td>61~70</td>
								<td></td>
								<td><p align="center">-</p></td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
							</tr>
							<tr>
								<td>{{$t("investor_024")}}</td>
								<td>{{$t("investor_025")}}</td>
								<td>{{$t("investor_022")}}</td>
								<td>{{$t("investor_026")}}</td>
								<td>71~80</td>
								<td></td>
								<td><p align="center">-</p></td>
								<td>V</td>
								<td></td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
							</tr>
							<tr>
								<td>{{$t("investor_024")}}</td>
								<td>{{$t("investor_028")}}</td>
								<td>{{$t("investor_022")}}</td>
								<td>{{$t("investor_023")}}</td>
								<td>61~70</td>
								<td></td>
								<td><p align="center">-</p></td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
							</tr>
							<tr>
								<td>{{$t("investor_030")}}</td>
								<td>{{$t("investor_031")}}</td>
								<td>{{$t("investor_022")}}</td>
								<td>{{$t("investor_026")}}</td>
								<td>51~60</td>
								<td></td>
								<td>{{$t("investor_035-1")}}</td>
								<td>V</td>
								<td></td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
							</tr>
							<tr>
								<td>{{$t("investor_030")}}</td>
								<td>{{$t("investor_033")}}</td>
								<td>{{$t("investor_022")}}</td>
								<td>{{$t("investor_026")}}</td>
								<td>61~70</td>
								<td></td>
								<td>{{$t("investor_035-1")}}</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
							</tr>
							<tr>
								<td>{{$t("investor_030")}}</td>
								<td>{{$t("investor_034")}}</td>
								<td>{{$t("investor_022")}}</td>
								<td>{{$t("investor_026")}}</td>
								<td>61~70</td>
								<td></td>
								<td>{{$t("investor_035-1")}}</td>
								<td>V</td>
								<td></td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
							</tr>
              <tr>
								<td>{{$t("investor_030")}}</td>
								<td>{{$t("investor_032")}}</td>
								<td>{{$t("investor_022")}}</td>
								<td>{{$t("investor_023")}}</td>
								<td>51-60</td>
								<td></td>
								<td>{{$t("investor_035")}}</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
								<td>V</td>
							</tr>
						</table>
            </div>
            <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'||$i18n.locale=='cn'"></p>
			<p v-else><a  href="../../static/files/114年董事會進修情形.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">114董事會進修情形</a></p>
      <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'||$i18n.locale=='cn'"></p>
			<p v-else><a  href="../../static/files/114年董事會運作情形.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">114董事會運作情形</a></p>

<br>
      <h3>{{$t("investor_02001")}}</h3>
						<table class="table table-bordered" border="1" style="width:100%;">
							<tr>
								<td>{{$t("investor_02002")}}</td>
								<td>{{$t("investor_02003")}}</td>
							</tr>
							<tr>
								<td>{{$t("investor_02004")}}</td>
								<td>{{$t("investor_02009")}}</td>
							</tr>
							<tr>
								<td>{{$t("investor_02005")}}</td>
								<td>{{$t("investor_02009")}}</td>
							</tr>
							<tr>
								<td>{{$t("investor_02006")}}</td>
								<td>{{$t("investor_02009")}}</td>
							</tr>
							<tr>
								<td>{{$t("investor_02007")}}</td>
								<td>{{$t("investor_02009")}}</td>
							</tr>
							<tr>
								<td>{{$t("investor_02008")}}</td>
								<td>{{$t("investor_02009")}}</td>
							</tr>
						</table>
      <h3>{{$t("investor_604")}}</h3>
      <p>{{$t("investor_605")}}</p>
      <p>{{$t("investor_606")}}</p>
      <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'||$i18n.locale=='cn'"><a  href="../../static/files/2024 Performance evaluation of the Board of Directors.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2024 Performance evaluation of the Board of Directors.pdf</a></p>
			<p v-else><a  href="../../static/files/113年績效評估結果.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">113年績效評估結果</a></p>
      <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'||$i18n.locale=='cn'"><a  href="../../static/files/2023 Performance evaluation of the Board of Directors.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2023 Performance evaluation of the Board of Directors.pdf</a></p>
      <p v-else><a  href="../../static/files/112年績效評估結果.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">112年績效評估結果</a></p>
      <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'||$i18n.locale=='cn'"><a  href="../../static/files/2022 Performance evaluation of the Board of Directors.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2022 Performance evaluation of the Board of Directors.pdf</a></p>
			<p v-else><a  href="../../static/files/111年績效評估結果.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">111年績效評估結果</a></p>

          <br>

          <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
          <p>External Board Performance Evaluation
The Company commissioned the Taiwan Investor Relations Institute to conduct an external evaluation in 2023. Please refer to the
document on the complete 2023 evaluation report for more information about the Company’s Board performance.
</p>  <p><a  href="../../static/files/112年董事會績效評估報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2023 External Board Performance Report</a></p>
           <p><a  href="../../static/files/112董事會績效評估證明.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">2023 External Board Performance</a></p>
</span>
          <span v-else>

          <h4>外部評估結果</h4>
            <p>一、112年董事會績效評估外評情形</p>
            <p>依本公司董事會績效評估辦法，應至少每三年由外部專業獨立機構或外部專家學者團執行一次董事會績效評估。本公司委由「台灣投資人關係協會」執行112年度本公司董事會績效評估，該協會及委派執行之三位專家與本公司均無業務往來且具獨立性，並於113年1月22日出具董事會績效評估報告。前揭外部評估結果已提報本公司113年1月24日第5屆第6次董事會報告，詳細執行情形如下：</p>
            <p style="margin-left:2em;padding-right:2em;">(一)評估期間：112年1月1日至112年12月31日。</p>
            <p style="margin-left:2em;padding-right:2em;">(二)評估方式：由前揭協會發放問卷予全體董事成員並100%回收，並實地訪談本公司董事長、公司治理主管與稽核主管，及視訊訪談審計委員會召集人。</p>
            <p style="margin-left:2em;padding-right:2em;">(三)評估內容與項目：以整體董事會(包含其下之功能性委員會)之組成及專業發展、決策品質、運作效能、內部控制及風險管理及參與企業社會責任程度等五大構面，以自評問卷與實地及視訊訪查方式進行評核。</p>
            <p>二、外部董事會績效評估結果摘要說明：</p>
            <p style="margin-left:2em;padding-right:2em;">(一)總評：</p>
            <p style="margin-left:5em;padding-right:6em;">1.	本公司9席董事，由5席董事及4席獨立董事組成，董事長與總經理非為配偶或一親等親屬關係，顯示董事長及總經理之職能分明；董事長與董事不超過二人具有配偶或二親等以內之親屬關係，顯示董事會對公司財務業務能做出客觀獨立之判斷；而董事成員中具本公司、母、子或兄弟公司員工身分之人數，未逾董事席次三分之一，對存有潛在利益衝突時，董事會能考慮指派人數足夠且能做出獨立判斷之非執行董事；女性董事席次達三分之一以上，顯示落實推動我國性別平等政策綱領，提高女性決策參與並健全董事會結構；四席獨立董事達董事席次三分之一以上且其連續任期均不超過三屆，顯示獨立董事能客觀行使職權，避免因久任致降低獨立性。而為強化獨立董事參與董事會之運作，112年度召開八次董事會，全體董事實際出席率為100%，顯示董事間有足夠溝通與交流機會。此外，已制定董事會成員及重要管理階層之接班規劃，藉以維持董事會及高階管理階層之專業及經驗度，並確保企業永續經營。</p>
            <p style="margin-left:5em;padding-right:6em;">2.	為公司強化資通安全之風險管理，落實資訊安全管理政策有效推動，已設置資訊安全推動組，由總經理擔任召集人，定期召開會議就資訊安全管理執行情形及資訊安全相關事項進行研議，以提升整體資安防護能量。</p>
            <p style="margin-left:5em;padding-right:6em;">3.	已設置企業誠信經營專責單位為總經理室法務主管，並已於112年11月9日董事會進行誠信作業進度報告；另於112年6月23日董事會通過設置風險管理委員會，並委任總管理處協理為公司治理主管負責公司治理相關事務，以健全企業之公司治理，並於112年12月20日董事會進行風險管理運作情形報告。此外，因重視永續發展議題，建立推動永續發展之治理架構，已成立永續報告負責小組，定期向董事會彙報，並分別於112年8月29日及9月28日上傳民國111年度中、英文版永續報告書，並經第三方勤業眾信聯合會計師事務所，採用標準確信準則3000號進行驗證。</p>
            <p style="margin-left:2em">(二)建議：</p>
            <p style="margin-left:5em;padding-right:6em;">1.	為因應國際趨勢，有效落實ESG，企業應由上而下推動。依據上市櫃公司永續展行動方案推動時程中，民國114年證交所及櫃買中心將研議強制上市櫃公司設置永續委員會之可行性。建議提早成立「永續發展委員會」之功能性委員會，以協助董事會持續推動及強化公司永續經營與企業社會責任相關之公司治理。</p>
            <p style="margin-left:5em;padding-right:6em;">2.	為提升上市公司財務資訊揭露時效及品質，建議參酌民國112年(第十屆)公司治理評鑑3.4指標，於會計年度結束後兩個月內公布經會計師查核簽證之年度財務報告，早於法令規定申報年度財務報告之標準，有利投資人能以平等、即時且低成本獲取攸關的訊息。</p>
            <p style="margin-left:5em;padding-right:6em;">3.	依據上市櫃公司永續發展行動方案推動時程中，預計民國113年證交所訂定董事及高階經理人薪酬與 ESG績效連結之公司治理評鑑指標參考範例並進行宣導，建議公司提早規劃董事及高階經理人薪酬與ESG績效連結，透過訂定指標促使決策融合環境或社會等層面，有助公司達成永續發展目標。</p>
            <p style="margin-left:2em;padding-right:2em;">(三)因應做法</p>
            <p style="margin-left:5em;padding-right:6em;">1.	將研擬設置永續發展委員會，擬提案將原永續報告負責小組(永續發展推動組)、風險管理推動與執行小組、資訊安全推動組及溫室氣體盤查及查證小組，共同整併至永續發展委員會下，將視實際需求邀請相關專業之獨立董事及董事共同組成永續發展委員會。</p>
            <p style="margin-left:5em;padding-right:6em;">2.	本公司將自113年起於每會計年度終了後75日內申報經董事會通過之年度自結財務資訊電子檔，而為投資人能盡早可獲得攸關的資訊，將規劃逐步提早年度財務報告申報之日期。</p>
            <p style="margin-left:5em;padding-right:6em;">3.	為深植本公司永續企業文化，將研擬高階經理人薪酬與ESG績效制度，高階經理人之績效考核項目將納入所屬單位業務相關制定之ESG指標，將經理人薪酬與ESG連結，以強化本公司永續發展政策之落實及執行。</p>
            <p><a  href="../../static/files/112年董事會績效評估報告.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">112年董事會績效評估報告</a></p>
         <p><a  href="../../static/files/112董事會績效評估證明.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">112董事會績效評估證明</a></p> </span>

        </div></div>

            </div></div>
            <div ref="top3" id="top3" class="about-box-01">    <!--審計委員會 -->
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_03")}}</h3>

			<p>{{$t("investor_036")}}</p><br>
      <p>{{$t("investor_037")}}</p>
			<p>●{{$t("investor_038")}}</p>
			<p>●{{$t("investor_039")}}</p>
			<p>●{{$t("investor_040")}}</p>
			<p>●{{$t("investor_041")}}</p>
			<p>●{{$t("investor_042")}}</p>
			<p>●{{$t("investor_043")}}</p>
      <p>●{{$t("investor_044")}}</p>
      <p>●{{$t("investor_045")}}</p>
      <p>●{{$t("investor_046")}}</p>
      <p>●{{$t("investor_047")}}</p>
      <p>●{{$t("investor_048")}}</p>
      <p>●{{$t("investor_049")}}</p>
      <p>●{{$t("investor_050")}}</p>
			<p>●{{$t("investor_051")}}</p>
          <br /><br />
       <p>{{$t("investor_052")}}</p>
          <table class="table-bordered" border="1" cellspacing="5" cellpadding="5" >
					<tr><td>{{$t("investor_004")}}</td><td>{{$t("investor_005")}}</td><td>{{$t("investor_053")}}(Ｂ)</td><td>{{$t("investor_054")}}</td><td>{{$t("investor_055_1")}}(A)</td><td>{{$t("investor_055")}}(%)【Ｂ/Ａ】</td><td>{{$t("investor_056")}}</td></tr>
					<tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_031")}}</td><td align="center">5</td><td align="center">0</td><td align="center">5</td><td align="center">100</td><td>-</td></tr>
					<tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_401")}}</td><td align="center">5</td><td align="center">0</td><td align="center">5</td><td align="center">100</td><td>-</td></tr>
					<tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_033")}}</td><td align="center">5</td><td align="center">0</td><td align="center">5</td><td align="center">100</td><td>-</td></tr>
					<tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_034")}}</td><td align="center">5</td><td align="center">0</td><td align="center">5</td><td align="center">100</td><td>-</td></tr>
				</table>
       <p> {{$t("investor_057")}}<br>
        {{$t("investor_058")}}<br>

				{{$t("investor_059")}}</p>
        <div class="table-responsive">
        <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
          <table class="table-bordered" border="1" cellspacing="5" cellpadding="5" style="width:100;">
					<tr style="text-align: center"><td>{{$t("investor_060")}}</td><td>{{$t("investor_061")}}</td><td>{{$t("investor_062")}}</td><td>{{$t("investor_063")}}</td><td>{{$t("investor_064")}}</td><td>{{$t("investor_065")}}</td></tr>
					<tr><td>{{$t("investor_066")}}</td><td>{{$t("investor_079")}}</td><td>{{$t("investor_092")}}<br />{{$t("investor_093")}}<br />{{$t("investor_094")}}<br />{{$t("investor_095")}}<br />{{$t("investor_096")}}<br />{{$t("investor_097")}}<br />{{$t("investor_098")}}</td><td>{{$t("investor_099")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_067")}}</td><td>{{$t("investor_080")}}</td><td>{{$t("investor_100")}}<br />{{$t("investor_101")}}<br />{{$t("investor_102")}}<br />{{$t("investor_103")}}<br />{{$t("investor_104")}}<br />{{$t("investor_105")}}<br />{{$t("investor_106")}}<br />{{$t("investor_107")}}<br />{{$t("investor_108")}}<br />{{$t("investor_109")}}<br />{{$t("investor_110")}}<br />{{$t("investor_111")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_068")}}</td><td>{{$t("investor_081")}}</td><td>{{$t("investor_112")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_069")}}</td><td>{{$t("investor_082")}}</td><td>{{$t("investor_113")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_070")}}</td><td>{{$t("investor_083")}}</td><td>{{$t("investor_114")}}<br />{{$t("investor_115")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_071")}}</td><td>{{$t("investor_084")}}</td><td>{{$t("investor_116")}}<br />{{$t("investor_117")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_072")}}</td><td>{{$t("investor_085")}}</td><td>{{$t("investor_118")}}<br />{{$t("investor_119")}}<br />{{$t("investor_120")}}<br />{{$t("investor_121")}}<br />{{$t("investor_122")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_073")}}</td><td>{{$t("investor_086")}}</td><td>{{$t("investor_123")}}<br />{{$t("investor_124")}}<br />{{$t("investor_125")}}<br />{{$t("investor_126")}}<br />{{$t("investor_127")}}<br />{{$t("investor_128")}}<br />{{$t("investor_129")}}<br />{{$t("investor_130")}}<br />{{$t("investor_131")}}<br />{{$t("investor_132")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_074")}}</td><td>{{$t("investor_087")}}</td><td>{{$t("investor_133")}}<br />{{$t("investor_134")}}<br />{{$t("investor_135")}}<br />{{$t("investor_136")}}<br />{{$t("investor_137")}}<br />{{$t("investor_138")}}<br />{{$t("investor_139")}}<br />{{$t("investor_140")}}<br />{{$t("investor_141")}}<td>{{$t("investor_162")}}</td></td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_075")}}</td><td>{{$t("investor_088")}}</td><td>{{$t("investor_142")}}<br />{{$t("investor_143")}}<br />{{$t("investor_144")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_076")}}</td><td>{{$t("investor_089")}}</td><td>{{$t("investor_145")}}<br />{{$t("investor_146")}}<br />{{$t("investor_147")}}<br />{{$t("investor_148")}}<br />{{$t("investor_149")}}<br />{{$t("investor_150")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_077")}}</td><td>{{$t("investor_090")}}</td><td>{{$t("investor_151")}}<br />{{$t("investor_152")}}<br />{{$t("investor_153")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_078")}}</td><td>{{$t("investor_091")}}</td><td>{{$t("investor_154")}}<br />{{$t("investor_155")}}<br />{{$t("investor_156")}}<br />{{$t("investor_157")}}<br />{{$t("investor_158")}}<br />{{$t("investor_159")}}<br />{{$t("investor_160")}}<br />{{$t("investor_161")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_553")}}</td><td>{{$t("investor_559")}}</td><td>{{$t("investor_565")}}<br />{{$t("investor_566")}}<br />{{$t("investor_567")}}<br />{{$t("investor_568")}}<br />{{$t("investor_569")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_554")}}</td><td>{{$t("investor_560")}}</td><td>{{$t("investor_570")}}<br />{{$t("investor_571")}}<br />{{$t("investor_572")}}<br />{{$t("investor_573")}}<br />{{$t("investor_574")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_555")}}</td><td>{{$t("investor_561")}}</td><td>{{$t("investor_575")}}<br />{{$t("investor_576")}}<br />{{$t("investor_577")}}<br />{{$t("investor_578")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_556")}}</td><td>{{$t("investor_562")}}</td><td>{{$t("investor_579")}}<br />{{$t("investor_580")}}<br />{{$t("investor_581")}}<br />{{$t("investor_582")}}<br />{{$t("investor_583")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_557")}}</td><td>{{$t("investor_563")}}</td><td>{{$t("investor_584")}}<br />{{$t("investor_585")}}<br />{{$t("investor_586")}}<br />{{$t("investor_587")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_558")}}</td><td>{{$t("investor_564")}}</td><td>{{$t("investor_588")}}<br />{{$t("investor_589")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>4th session of the 2nd term</td><td>2024/1/24</td><td>1. Proposed to invest in a new domestic subsidiary to operate pork cutting business<br />2. The Company’s plan to lend funds to Bafang Yunji Restaurant Co., Ltd.<br />3. Proposal for endorsement guarantees for the subsidiaries Bafang Yunji Foods LLC and Bafang Yunji Restaurant Group LLC</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>5th session of the 2nd term</td><td>2024/3/11</td><td>1.The Company's 2023 final business and accounting reports<br />2. The Company's earnings distribution proposal for 2023<br />3. CPAs’professional fee and evaluation of their independence for 2024<br />4. Issuance of the Company's “Statement of Internal Control System”<br />5. Proposal for endorsement guarantees for the subsidiaries Bafang Yunji Restaurant Group LLC<br />6. Proposal for amendments to the Company's“Operational Procedure for Preparation and Validation of the Sustainability Report”</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>6th session of the 2nd term</td><td>2024/5/8</td><td>1.Proposal to approve the Company’s consolidated financial statements for Q1 2024.<br />2.Proposal to increase capital in the subsidiary Bafang Yunji International (USA) Limited and further increase capital in the subsidiaries Bafang Yunji Foods LLC and Bafang Yunji Restaurant Group LLC.<br />3.Proposal to increase capital in the subsidiary Ji Yuan Foods Co., Ltd.<br />4.Proposal for the Company to provide a loan to the subsidiary Dante Coffee Foods Co., Ltd.<br />5.Proposal for the Company to provide a loan to Bafang Yunji Restaurant Group LLC.<br />6.Proposal to pre-approve non-assurance services to be provided by the auditor in 2024.</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>7th session of the 2nd term</td><td>2024/7/9</td><td>1.Proposal for capital increase in the subsidiary, Ji Yuan Foods Co., Ltd.<br />2.Proposal for capital increase in Bafang Yunji International (USA) Limited, with subsequent indirect investment to establish two U.S. subsidiaries.<br />3.Proposal for the U.S. subsidiary to acquire real estate.<br />4.The Company's proposal to cancel the endorsement guarantee for the subsidiary, Bafang Yunji Restaurant Group LLC.<br />5.Proposal to amend the Company's internal control system, specifically the “Computerized Information Systems,” and to add a new section on “Computerized Information Systems Security.”</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>8th session of the 2nd term</td><td>2024/8/7</td><td>1.Proposal to approve the Company's 2024 first half-year business report and the 2nd quarter consolidated financial statements.<br />2. Proposal for the 2024 first half-year earnings distribution.<br />3. The Company's proposal for the appointment and removal of the Chief Financial Officer and the change of the acting spokesperson.<br />4. Proposal to appoint a Company representative for matters under Articles 213, 214, and 223 of the Company Act.</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>9th session of the 2nd term</td><td>2024/11/6</td><td>1. Proposal to approve the Company's 2024 3rd quarter consolidated financial statements.<br />2. Proposal to acquire minority shares in subsidiary, Ji Yuan Foods Co., Ltd.<br />3. Proposal to increase capital for subsidiary, Bafang Yunji International (USA) Limited and indirectly invest to establish U.S. subsidiaries.<br />4. The Company's proposal for endorsement guarantees for subsidiary, Ji Yuan Foods Co., Ltd.<br />5. Proposal to amend the Company's “Approval Authority Table.”<br />6. Proposal to establish the Company's “Sustainability Information Management Procedures.”<br />7. Proposal to amend the Company's “Sustainable Development Practices Code.”<br />8. Proposal to amend the Company's “Board of Directors Meeting Regulations.”<br />9. Proposal to amend the Company's “Internal Handling Procedures for Material Information.”<br />10. Proposal to amend the Company's “Insider Trading Prevention Management Procedures.”<br />11.Proposal to establish the Company's 2025 audit plan.
          </td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
         </table>
        </span><span v-else>
        <table class="table-bordered" border="1" cellspacing="5" cellpadding="5" style="width:100;">
					<tr style="text-align: center"><td>{{$t("investor_060")}}</td><td>{{$t("investor_061")}}</td><td>{{$t("investor_062")}}</td><td>{{$t("investor_063")}}</td><td>{{$t("investor_064")}}</td><td>{{$t("investor_065")}}</td></tr>
					<tr><td>{{$t("investor_066")}}</td><td>{{$t("investor_079")}}</td><td>{{$t("investor_092")}}<br />{{$t("investor_093")}}<br />{{$t("investor_094")}}<br />{{$t("investor_095")}}<br />{{$t("investor_096")}}<br />{{$t("investor_097")}}<br />{{$t("investor_098")}}</td><td>{{$t("investor_099")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_067")}}</td><td>{{$t("investor_080")}}</td><td>{{$t("investor_100")}}<br />{{$t("investor_101")}}<br />{{$t("investor_102")}}<br />{{$t("investor_103")}}<br />{{$t("investor_104")}}<br />{{$t("investor_105")}}<br />{{$t("investor_106")}}<br />{{$t("investor_107")}}<br />{{$t("investor_108")}}<br />{{$t("investor_109")}}<br />{{$t("investor_110")}}<br />{{$t("investor_111")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_068")}}</td><td>{{$t("investor_081")}}</td><td>{{$t("investor_112")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_069")}}</td><td>{{$t("investor_082")}}</td><td>{{$t("investor_113")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_070")}}</td><td>{{$t("investor_083")}}</td><td>{{$t("investor_114")}}<br />{{$t("investor_115")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_071")}}</td><td>{{$t("investor_084")}}</td><td>{{$t("investor_116")}}<br />{{$t("investor_117")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_072")}}</td><td>{{$t("investor_085")}}</td><td>{{$t("investor_118")}}<br />{{$t("investor_119")}}<br />{{$t("investor_120")}}<br />{{$t("investor_121")}}<br />{{$t("investor_122")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_073")}}</td><td>{{$t("investor_086")}}</td><td>{{$t("investor_123")}}<br />{{$t("investor_124")}}<br />{{$t("investor_125")}}<br />{{$t("investor_126")}}<br />{{$t("investor_127")}}<br />{{$t("investor_128")}}<br />{{$t("investor_129")}}<br />{{$t("investor_130")}}<br />{{$t("investor_131")}}<br />{{$t("investor_132")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_074")}}</td><td>{{$t("investor_087")}}</td><td>{{$t("investor_133")}}<br />{{$t("investor_134")}}<br />{{$t("investor_135")}}<br />{{$t("investor_136")}}<br />{{$t("investor_137")}}<br />{{$t("investor_138")}}<br />{{$t("investor_139")}}<br />{{$t("investor_140")}}<br />{{$t("investor_141")}}<td>{{$t("investor_162")}}</td></td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_075")}}</td><td>{{$t("investor_088")}}</td><td>{{$t("investor_142")}}<br />{{$t("investor_143")}}<br />{{$t("investor_144")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_076")}}</td><td>{{$t("investor_089")}}</td><td>{{$t("investor_145")}}<br />{{$t("investor_146")}}<br />{{$t("investor_147")}}<br />{{$t("investor_148")}}<br />{{$t("investor_149")}}<br />{{$t("investor_150")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_077")}}</td><td>{{$t("investor_090")}}</td><td>{{$t("investor_151")}}<br />{{$t("investor_152")}}<br />{{$t("investor_153")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
					<tr><td>{{$t("investor_078")}}</td><td>{{$t("investor_091")}}</td><td>{{$t("investor_154")}}<br />{{$t("investor_155")}}<br />{{$t("investor_156")}}<br />{{$t("investor_157")}}<br />{{$t("investor_158")}}<br />{{$t("investor_159")}}<br />{{$t("investor_160")}}<br />{{$t("investor_161")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_553")}}</td><td>{{$t("investor_559")}}</td><td>{{$t("investor_565")}}<br />{{$t("investor_566")}}<br />{{$t("investor_567")}}<br />{{$t("investor_568")}}<br />{{$t("investor_569")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_554")}}</td><td>{{$t("investor_560")}}</td><td>{{$t("investor_570")}}<br />{{$t("investor_571")}}<br />{{$t("investor_572")}}<br />{{$t("investor_573")}}<br />{{$t("investor_574")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_555")}}</td><td>{{$t("investor_561")}}</td><td>{{$t("investor_575")}}<br />{{$t("investor_576")}}<br />{{$t("investor_577")}}<br />{{$t("investor_578")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_556")}}</td><td>{{$t("investor_562")}}</td><td>{{$t("investor_579")}}<br />{{$t("investor_580")}}<br />{{$t("investor_581")}}<br />{{$t("investor_582")}}<br />{{$t("investor_583")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_557")}}</td><td>{{$t("investor_563")}}</td><td>{{$t("investor_584")}}<br />{{$t("investor_585")}}<br />{{$t("investor_586")}}<br />{{$t("investor_587")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>{{$t("investor_558")}}</td><td>{{$t("investor_564")}}</td><td>{{$t("investor_588")}}<br />{{$t("investor_589")}}</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第四次</td><td>113.01.24</td><td>1.擬投資設立經營豬肉分切業務之國內子公司案<br />2.本公司擬資金貸與子公司八方雲集餐飲股份有限公司案<br />3. 本公司擬為子公司Bafang Yunji Foods LLC及Bafang Yunji Restaurant Group LLC背書保證案</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第五次</td><td>113.03.11</td><td>1.112年度決算表冊案<br />2.本公司112年度盈餘分配案<br />3.113年度會計師公費暨獨立性評估審核案<br />4.擬通過本公司之「內部控制制度聲明書」案<br />5.本公司擬為子公司Bafang Yunji Restaurant Group LLC背書保證案<br />6.擬修訂本公司「永續報告書編製及驗證之作業程序」案</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第六次</td><td>113.05.08</td><td>1.擬通過本公司2024年第1季合併財務報表案<br />2.擬增資子公司Bafang Yunji International (USA) Limited及再轉增資子公司Bafang Yunji Foods LLC及子公司Bafang Yunji Restaurant Group LLC案<br />3.擬增資子公司集元食品股份有限公司案<br />4.本公司擬資金貸與子公司丹堤咖啡食品股份有限公司案<br />5.本公司擬資金貸與Bafang Yunji Restaurant Group LLC案<br />6.擬預先核准2024年簽證會計師提供非確信服務項目案</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第七次</td><td>113.07.09</td><td>1.擬增資子公司集元食品股份有限公司案<br />2.擬增資子公司Bafang Yunji International (USA) Limited及再間接投資設立兩家美國子公司案<br />3.美國子公司擬取得不動產案<br />4.本公司擬取消為子公司Bafang Yunji Restaurant Group LLC背書保證案<br />5.擬修訂本公司內部控制制度「電腦化資訊系統」及增訂「電腦化資訊系統安全」案</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第八次</td><td>113.08.07</td><td>1.擬通過本公司113年上半年度營業報告書及第2季合併財務報表案<br />2.113年上半年度盈餘分配案<br />3.本公司財務長任免及代理發言人異動案<br />4.擬選任適用公司法第213條、第214條及第223條事項之公司代表人</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第九次</td><td>113.11.06</td><td>1.擬通過本公司2024年第3季合併財務報表案<br />2.擬取得子公司集元食品股份有限公司少數股權案<br />3.擬增資子公司Bafang Yunji International (USA) Limited及間接投資設立美國子公司案<br />4.本公司擬為子公司集元食品股份有限公司背書保證案<br />5.擬修訂本公司「核決權限表」案<br />6.擬訂定本公司「永續資訊管理作業辦法」案<br />7.擬修訂本公司「永續發展實務守則」案<br />8.擬修訂本公司「董事會議事規範」案<br />9.擬修訂本公司「內部重大資訊處理作業程序」案<br />10.擬修訂本公司「防範內線交易管理辦法」案<br />11.擬訂定本公司114年度稽核計劃案</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第十次</td><td>114.01.16</td><td>本公司擬為美國子公司背書保證案</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第十一次</td><td>114.03.13</td><td>1.113年度決算表冊案<br />2.本公司113年度盈餘分配案<br />3.擬修訂本公司章程案<br />4.114年度會計師公費暨獨立性評估審核案<br />5.本公司更換簽證會計師案<br />6.擬通過本公司之「內部控制制度聲明書」案<br />7.本公司擬為子公司Bafang Yunji Restaurant Group LLC背書保證案<br />8.本公司擬為子公司Bafang Yunji Foods LLC及Bafang Yunji Restaurant Group LLC及背書保證案<br />9.本公司擬為子公司八方雲集餐飲股份有限公司背書保證案<br />10.本公司擬取得不動產案</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第十二次</td><td>114.05.07</td><td>1.擬通過本公司2025年第1季合併財務報表案<br />2.擬預先核准2025年簽證會計師提供非確信服務項目案<br />3.本公司稽核主管委任案</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第十三次</td><td>114.08.12</td><td>1.擬通過本公司114年上半年度營業報告書及第2季合併財務報表案<br />2.114年上半年度盈餘分配案<br />3.本公司擬發行國內第一次暨第二次無擔保轉換公司債案<br />4.擬增資子公司Bafang Yunji International (USA) Limited及間接增資子公司Bafang Yunji Foods LLC案<br />5.擬增資子公司Bafang Yunji International (USA) Limited及間接增資子公司Bafang Yunji Foods Texas LLC案<br />6.本公司擬取得不動產案</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
          <tr><td>第二屆第十四次</td><td>114.11.11</td><td>1.擬通過本公司2025年第3季合併財務報表案<br />2.擬修正本公司「永續發展實務守則」案<br />3.擬修正本公司「風險管理政策及程序」案<br />4.擬修正本公司「永續報告書編製及確信之作業程序」案<br />5.擬訂定本公司115年度稽核計畫案<br />6.本公司會計主管異動案</td><td>{{$t("investor_162")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
         </table>
         </span>
        </div>
        <p>  {{$t("investor_165")}}<br>
				{{$t("investor_166")}}</p>
      <br><br>

				<h3>{{$t("investor_167")}}</h3>
        <div class="table-responsive">
				<table class="table-bordered" border="1" cellspacing="5" cellpadding="5" style="width:100%;">
					<tr>
						<td>{{$t("investor_169")}}</td>
						<td>{{$t("investor_168")}}</td>
            <td>{{$t("investor_181")}}</td>
            <td>{{$t("investor_170")}}</td>
					</tr>
          <tr>
						<td colspan="4" align='center'>{{$t("investor_167-1")}}</td>
					</tr>
					<tr>
						<td>{{$t("investor_171-1")}}</td>
						<td>{{$t("investor_171")}}</td>
            <td>V</td>
            <td></td>
					</tr>
					<tr>
						<td>{{$t("investor_172-1")}}</td>
						<td>{{$t("investor_172")}}</td>
            <td>V</td>
            <td></td>
					</tr>
					<tr>
						<td>{{$t("investor_173-1")}}</td>
						<td>{{$t("investor_173")}}</td>
            <td>V</td>
            <td></td>
					</tr>
					<tr>
						<td>{{$t("investor_174-1")}}</td>
						<td>{{$t("investor_174")}}</td>
            <td>V</td>
            <td></td>
					</tr>
					<tr>
						<td>{{$t("investor_175-1")}}</td>
						<td>{{$t("investor_175")}}</td>
            <td>V</td>
            <td></td>
					</tr>
					<tr>
						<td>{{$t("investor_176-1")}}</td>
						<td>{{$t("investor_176")}}</td>
            <td>V</td>
            <td></td>
					</tr>
					<tr>
						<td>{{$t("investor_177-1")}}</td>
						<td>{{$t("investor_177")}}</td>
            <td>V</td>
            <td></td>
					</tr>
					<tr>
						<td>{{$t("investor_178-1")}}</td>
						<td>{{$t("investor_178")}}</td>
            <td>V</td>
            <td></td>
					</tr>
          <tr>
						<td><p>{{$t("investor_179-1")}}</p></td>
						<td><p>{{$t("investor_179")}}</p></td>
            <td>V</td>
            <td></td>
					</tr>
          <tr>
						<td><p>{{$t("investor_180-1")}}</p></td>
						<td><p>{{$t("investor_180")}}</p></td>
            <td>V</td>
            <td></td>
					</tr>
          <tr>
						<td><p>{{$t("investor_1811-1")}}</p></td>
						<td><p>{{$t("investor_1811")}}</p></td>
            <td>V</td>
            <td></td>
					</tr>
          <tr>
						<td colspan="4" align='center'>{{$t("investor_167-2")}}</td>
					</tr>
          <tr>
						<td><p>{{$t("investor_171-1")}}</p></td>
						<td><p>{{$t("investor_1711")}}</p></td>
            <td>V</td>
            <td></td>
					</tr>
          <tr>
						<td><p>{{$t("investor_172-1")}}</p></td>
						<td><p>{{$t("investor_1722")}}</p></td>
            <td>V</td>
            <td></td>
					</tr>
          <tr>
						<td><p>{{$t("investor_173-1")}}</p></td>
						<td><p>{{$t("investor_1733")}}</p></td>
            <td>V</td>
            <td></td>
					</tr>
          <tr>
						<td><p>{{$t("investor_174-1")}}</p></td>
						<td><p>{{$t("investor_1744")}}</p></td>
            <td>V</td>
            <td></td>
					</tr>
          <tr>
						<td><p>{{$t("investor_175-1")}}</p></td>
						<td><p>{{$t("investor_1755")}}</p></td>
            <td>V</td>
            <td></td>
					</tr>          
				</table>
        </div>
			</div>
              </div></div></div>
              <div ref="top4" id="top4" class="about-box-01">  <!--薪酬委員會 -->
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_04")}}</h3>
      <br />
      <strong>{{$t("investor_182")}}</strong><br />
      <p>
            {{$t("investor_183")}}<br />
						{{$t("investor_184")}}<br />
            {{$t("investor_185")}}<br />
            {{$t("investor_186")}}<br />
            {{$t("investor_187")}}<br />
						{{$t("investor_188")}}<br />
            {{$t("investor_184_1")}}<br />
						</p><br />
          <p>{{$t("investor_189")}}</p>
						<br />

				<table class="table-bordered"  cellspacing="5" cellpadding="5" style="width:100%;">
            <tr><td>{{$t("investor_004")}}</td><td>{{$t("investor_005")}}</td><td>{{$t("investor_053")}}(Ｂ)</td><td>{{$t("investor_054")}}</td><td>{{$t("investor_055_1")}}(A)</td><td>{{$t("investor_055")}}(%)【Ｂ/Ａ】</td><td>{{$t("investor_056")}}</td></tr>
            <tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_031")}}</td><td align="center">5</td><td align="center">0</td><td align="center">5</td><td align="center">100</td><td>-</td></tr>
            <tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_401")}}</td><td align="center">5</td><td align="center">0</td><td align="center">5</td><td align="center">100</td><td>-</td></tr>
            <tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_033")}}</td><td align="center">5</td><td align="center">0</td><td align="center">5</td><td align="center">100</td><td>-</td></tr>
            <tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_034")}}</td><td align="center">5</td><td align="center">0</td><td align="center">5</td><td align="center">100</td><td>-</td></tr>
        </table>
							<tr><td colspan="6">{{$t("investor_195")}}<br />
							<p>{{$t("investor_196")}}</p>
              <p>{{$t("investor_197")}}</p>
              <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
									<table class="table-bordered" cellspacing="5" cellpadding="5" style="width:100%;">
										<tr><td>{{$t("investor_060")}}</td><td>{{$t("investor_061")}}</td><td>{{$t("investor_062")}}</td><td>{{$t("investor_223")}}</td><td>{{$t("investor_224")}}</td></tr>
										<tr><td>{{$t("investor_198")}}</td><td>{{$t("investor_201")}}</td><td>{{$t("investor_211")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_199")}}</td><td>{{$t("investor_202")}}</td><td>{{$t("investor_212")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_200")}}</td><td>{{$t("investor_203")}}</td><td>{{$t("investor_213")}}<br />{{$t("investor_214")}}<br />{{$t("investor_215")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_066")}}</td><td>{{$t("investor_204")}}</td><td>{{$t("investor_216")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_067")}}</td><td>{{$t("investor_205")}}</td><td>{{$t("investor_217")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_068")}}</td><td>{{$t("investor_206")}}</td><td>{{$t("investor_218")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_069")}}</td><td>{{$t("investor_207")}}</td><td>{{$t("investor_219")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_070")}}</td><td>{{$t("investor_208")}}</td><td>{{$t("investor_220")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_071")}}</td><td>{{$t("investor_209")}}</td><td>{{$t("investor_221")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_072")}}</td><td>{{$t("investor_210")}}</td><td>{{$t("investor_222")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>{{$t("investor_073")}}</td><td>{{$t("investor_403")}}</td><td>{{$t("investor_406")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>{{$t("investor_074")}}</td><td>{{$t("investor_404")}}</td><td>{{$t("investor_407")}}<br />{{$t("investor_408")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>{{$t("investor_402")}}</td><td>{{$t("investor_405")}}</td><td>{{$t("investor_409")}}<br />{{$t("investor_410")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>2nd session of the 2nd term</td><td>2024.01.24</td><td>1.Distribution of 2023 year-end bonuses for the Chairman and managerial officers<br />2.Adjustment of salary and compensation for the company's managers</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>3rd session of the 2nd term</td><td>2024.03.11</td><td>2023 employee compensation and remuneration to directors</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>4th session of the 2nd term</td><td>2024.05.08</td><td>1.Salary compensation proposal for new managers<br />2.Salary adjustment proposal for the company's managers</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>5th session of the 2nd term</td><td>2024.08.07</td><td>1.Salary compensation proposal for new managers<br />2.Salary adjustment proposal for the company's managers<br />3.Distribution of employee compensation for 2023<br />4.Proposal for the company's “Executive Management Selection, Retention, Evaluation, and Termination Procedures”</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>6th session of the 2nd term</td><td>2024.08.29</td><td>Proposal for the retirement compensation for the company's senior managers</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>7th session of the 2nd term</td><td>2024.11.06</td><td>1.Salary compensation proposal for new managerial officers<br />2.Salary adjustment proposal for the company's managers<br />3.Revised employee compensation distribution proposal for 2023</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                  </table>
              </span>
              <span v-else>
                <table class="table-bordered" cellspacing="5" cellpadding="5" style="width:100%;">
										<tr><td>{{$t("investor_060")}}</td><td>{{$t("investor_061")}}</td><td>{{$t("investor_062")}}</td><td>{{$t("investor_223")}}</td><td>{{$t("investor_224")}}</td></tr>
										<tr><td>{{$t("investor_198")}}</td><td>{{$t("investor_201")}}</td><td>{{$t("investor_211")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_199")}}</td><td>{{$t("investor_202")}}</td><td>{{$t("investor_212")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_200")}}</td><td>{{$t("investor_203")}}</td><td>{{$t("investor_213")}}<br />{{$t("investor_214")}}<br />{{$t("investor_215")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_066")}}</td><td>{{$t("investor_204")}}</td><td>{{$t("investor_216")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_067")}}</td><td>{{$t("investor_205")}}</td><td>{{$t("investor_217")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_068")}}</td><td>{{$t("investor_206")}}</td><td>{{$t("investor_218")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_069")}}</td><td>{{$t("investor_207")}}</td><td>{{$t("investor_219")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_070")}}</td><td>{{$t("investor_208")}}</td><td>{{$t("investor_220")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_071")}}</td><td>{{$t("investor_209")}}</td><td>{{$t("investor_221")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
										<tr><td>{{$t("investor_072")}}</td><td>{{$t("investor_210")}}</td><td>{{$t("investor_222")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>{{$t("investor_073")}}</td><td>{{$t("investor_403")}}</td><td>{{$t("investor_406")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>{{$t("investor_074")}}</td><td>{{$t("investor_404")}}</td><td>{{$t("investor_407")}}<br />{{$t("investor_408")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>{{$t("investor_402")}}</td><td>{{$t("investor_405")}}</td><td>{{$t("investor_409")}}<br />{{$t("investor_410")}}</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第二次</td><td>113.01.24</td><td>1.發放董事長及經理人112年度年終獎金<br />2.本公司經理人調整薪資報酬案</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第三次</td><td>113.03.11</td><td>112年度員工酬勞及董事酬勞分配案</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第四次</td><td>113.05.08</td><td>1.本公司新任經理人薪資報酬案<br />2.本公司經理人薪資調整案</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第五次</td><td>113.08.07</td><td>1.本公司新任經理人薪資報酬案<br />2.本公司經理人薪資調整案<br />3.112年度員工酬勞發放案<br />4.擬訂定本公司「高階經理人之選用育留考離辦法」案</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第六次</td><td>113.08.29</td><td>本公司高階經理人退職酬金案</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第七次</td><td>113.11.06</td><td>1.本公司新任經理人薪資報酬案<br />2.本公司經理人薪資調整案<br />3.本公司112年度員工酬勞發放修正案</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第八次</td><td>114.01.16</td><td>1.發放董事長及經理人113年度年終獎金案<br />2.本公司高階經理人退職酬金案</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第九次</td><td>114.03.13</td><td>1.本公司新任經理人薪資報酬案，提請審議。<br />2.113年度員工酬勞及董事酬勞分配案，提請審議。<br />3.擬修訂員工酬勞實施辦法案，提請審議。</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第十次</td><td>114.05.07</td><td>本公司新任經理人薪資報酬案</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第十一次</td><td>114.08.12</td><td>1.本公司高階經理人退職酬金案<br />2.本公司經理人薪資調整案<br />3.113年度員工酬勞發放案</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                    <tr><td>第二屆第十二次</td><td>114.11.11</td><td>1.本公司新任會計主管薪資報酬案<br />2.擬修訂「經理人薪酬管理辦法」案，提請審議。<br />3.評估檢討董事及功能性委員會薪資報酬之政策、制度、標準與結構，提請審議。</td><td>{{$t("investor_163")}}</td><td>{{$t("investor_164")}}</td></tr>
                  </table>
              </span>
							</td>
            </tr>				

			</div>
              </div></div></div>
              <div ref="top5" id="top5" class="about-box-01">  <!--風險管理組織架構 -->
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_05")}}</h3>
      <h4>{{$t("investor_225_1")}}</h4>
      <p>{{$t("investor_225_2")}}</p><br/>
        <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
                <img src="../assets/images/Risk260112EN.jpg" width="100%" height="100%"/>
                </span><span v-else>
              <img src="../assets/images/Risk260112TW.jpg"  width="100%" height="100%"/>
            </span><br>

				<!-- <table class="table-bordered" border="1" style="width:100%;"> 20260112 整段都不要
					<tr><td>{{$t("investor_226")}}</td><td>{{$t("investor_227")}}</td></tr>
					<tr><td>{{$t("investor_02")}}</td><td>{{$t("investor_228")}}</td></tr>
					<tr><td>{{$t("investor_229")}}</td><td>{{$t("investor_230")}}<br />{{$t("investor_2301")}}<br />
            <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
                <img src="../assets/images/Risk250108EN.jpg" width="100%" height="100%"/>
                </span><span v-else>
              <img src="../assets/images/Risk250108TW.jpg"  width="100%" />
            </span><br><p> {{$t("investor_2311")}}</p>
                                        {{$t("investor_231")}}<br />
                                        {{$t("investor_232")}}<br />
                                        {{$t("investor_233")}}<br />
                                        {{$t("investor_234")}}<br />
                                        {{$t("investor_235")}}<br />
                                        {{$t("investor_236")}}<br />
          </td></tr>
					<tr><td>{{$t("investor_237")}}</td><td>{{$t("investor_238")}}</td></tr>
					<tr><td>{{$t("investor_239")}}</td><td>{{$t("investor_240")}}</td></tr>
          <tr><td>{{$t("investor_241")}}</td><td>{{$t("investor_242")}}</td></tr>
				</table> -->
      <h4>{{$t("investor_225_3")}}</h4>
      <h5>{{$t("investor_225_4")}}</h5>
      <p>{{$t("investor_225_5")}}</p>
        <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
                <img src="../assets/images/member260112EN.jpg" width="100%" height="100%"/>
                </span><span v-else>
              <img src="../assets/images/member260112TW.jpg"  width="100%" height="100%"/>
        </span><br>
        <br>
				<!-- <h4>{{$t("investor_243")}}</h4> 20260112 整段都不要
          <p>{{$t("investor_244")}}</p>
          <br />
        <h4>{{$t("investor_245")}}</h4>
          <p>{{$t("investor_246")}}</p>
          <br />
        <h4>{{$t("investor_247")}}</h4>
          <p>{{$t("investor_248")}}</p> -->
      <h5>{{$t("investor_225_6")}}</h5>
      <p>{{$t("investor_225_7")}}</p>

        <a href="../../static/files/114年董事會進修情形.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">114董事會進修情形</a>

       <table class="table-bordered" border="1" cellspacing="5" cellpadding="5" >
					<tr><td>{{$t("investor_004")}}</td><td>{{$t("investor_005")}}</td><td>{{$t("investor_615")}}</td></tr>
					<tr><td>{{$t("investor_020")}}</td><td>{{$t("investor_021")}}</td><td>1.董事會如何確保企業永續經營-從⼈才之發掘與培養談起<br />2.全球未來風險與永續轉型契機</td></tr>
					<tr><td>{{$t("investor_024")}}</td><td>{{$t("investor_028")}}</td><td>1.董事會如何確保企業永續經營-從⼈才之發掘與培養談起<br />2.全球未來風險與永續轉型契機<br />3. 2023國泰永續⾦融暨氣候變遷⾼峰論壇</td></tr>					
					<tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_031")}}</td><td>1.如何設計治理與管理，讓企業接班不再是永續經營的障礙<br />2.全球未來風險與永續轉型契機<br />3.從ESG企業永續發展看上市櫃公司的資安治理策略</td></tr>								
					<tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_032")}}</td><td>1.董事會如何確保企業永續經營-從⼈才之發掘與培養談起<br />2.全球未來風險與永續轉型契機</td></tr>		
					<tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_033")}}</td><td>1.董事會如何確保企業永續經營-從⼈才之發掘與培養談起<br />2.全球未來風險與永續轉型契機<br />3.台新淨零電力高峰論壇</td></tr>										
					<tr><td>{{$t("investor_030")}}</td><td>{{$t("investor_034")}}</td><td>1.董事會如何確保企業永續經營-從⼈才之發掘與培養談起<br />2.全球未來風險與永續轉型契機<br />3.賦能董事會成為引領永續治理的關鍵⼒量</td></tr>					
        </table>

      <h4>{{$t("investor_225_8")}}</h4>
      <p>{{$t("investor_225_9")}}</p>
      <p>{{$t("investor_225_10")}}</p>
      <p>{{$t("investor_225_11")}}</p>
      <p>{{$t("investor_225_12")}}</p>
      <p>{{$t("investor_225_13")}}</p>
      <p>{{$t("investor_225_14")}}</p>
      <p>{{$t("investor_225_15")}}</p>
      <p>{{$t("investor_225_16")}}</p>
      <p>{{$t("investor_225_17")}}</p>
      <p>{{$t("investor_225_18")}}</p>
      <p>{{$t("investor_225_19")}}</p>
      <p>{{$t("investor_225_20")}}</p>
      <p>{{$t("investor_225_21")}}</p>


      <h4>{{$t("investor_243")}}</h4>
      <p>{{$t("investor_244")}}</p>

      <h4>{{$t("investor_245")}}</h4>
      <p>{{$t("investor_246")}}</p>

      <h4>{{$t("investor_225_22")}}</h4>
      <p>{{$t("investor_225_23")}}</p>
      <p>{{$t("investor_225_24")}}</p>
      <p>{{$t("investor_225_25")}}</p>
      <p>{{$t("investor_225_26")}}</p>
      <p style="text-indent:2ch;">{{$t("investor_225_27")}}</p>
      <p style="text-indent:2ch;">{{$t("investor_225_28")}}</p>
      <p style="text-indent:2ch;">{{$t("investor_225_29")}}</p>
      <p style="text-indent:2ch;">{{$t("investor_225_30")}}</p>
      <p style="text-indent:2ch;">{{$t("investor_225_31")}}</p>
      <p style="text-indent:2ch;">{{$t("investor_225_32")}}</p>


			</div>
              </div></div></div>
              <div ref="top6" id="top6" class="about-box-01">  <!--公司制度規範 -->
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_06")}}</h3>
      <p><a href="../../static/files/公司章程.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">公司章程</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Corporate Governance Best Practice Principles.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Corporate Governance Best Practice Principles</a></p>
			<p v-else><a href="../../static/files/公司治理實務守則.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">公司治理實務守則</a></p>
      <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/RulesofProcedureforBoardofDirectorsMeetings.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Rules of Procedure for Board of Directors Meetings</a></p>
      <p v-else><a href="../../static/files/董事會議事規範(20241106).pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">董事會議事規範</a></p>
      <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Procedure for Handling Material Inside Information.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Procedure for Handling Material Inside Information</a></p>
      <p v-else><a href="../../static/files/防範內線交易管理辦法(20241106).pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">防範內線交易管理辦法</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/EthicalCorporateManagementBestPracticePrinciples.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Ethical Corporate Management Best Practice Principles</a></p>
      <p v-else><a href="../../static/files/誠信經營守則.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">誠信經營守則</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Procedures for Ethical Management and Guidelines for Conduct.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Procedures for Ethical Management and Guidelines for Conduct</a></p>
      <p v-else><a href="../../static/files/誠信經營作業程序及行為指南.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">誠信經營作業程序及行為指南</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Mechanism for violation of code of conduct.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Mechanism for violation of code of conduct</a></p>
      <p v-else><a href="../../static/files/誠信違反檢舉作業辦法.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">誠信違反檢舉作業辦法</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Guidelines for the Adoption of Codes of Ethical Conduct.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Guidelines for the Adoption of Codes of Ethical Conduct</a></p>
      <p v-else><a href="../../static/files/道德行為準則.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">道德行為準則</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Sustainable Development Best Practice Principles.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Sustainable Development Best Practice Principles</a></p>
      <p v-else><a href="../../static/files/永續發展實務守則_20260112.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">永續發展實務守則</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Audit Committee Charter.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Audit Committee Charter</a></p>
      <p v-else><a href="../../static/files/審計委員會組織規程.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">審計委員會組織規程</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Remuneration Committee Charter.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Remuneration Committee Charter</a></p>
      <p v-else><a href="../../static/files/薪資報酬委員會組織規程.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">薪資報酬委員會組織規程</a></p>
      <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></p>
      <p v-else><a href="../../static/files/風險管理委員會組織規程(已於114年8月12日更名).pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">風險管理委員會組織規程(已於114年8月12日更名)</a></p>

      <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px"></a></p>
      <p v-else><a href="../../static/files/永續發展暨風險管理委員會組織規程.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">永續發展暨風險管理委員會組織規程</a></p>

			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Rules of Procedure for Shareholders Meetings.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Rules of Procedure for Shareholders Meetings</a></p>
      <p v-else><a href="../../static/files/股東會議事規則.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">股東會議事規則</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Procedures for Election of Directors.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Procedures for Election of Directors</a></p>
      <p v-else><a href="../../static/files/董事選任程序.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">董事選任程序</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Rules Governing the Scope of Powers of Independent Directors.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Rules Governing the Scope of Powers of Independent Directors</a></p>
      <p v-else><a href="../../static/files/獨立董事之職責範疇規則.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">獨立董事之職責範疇規則</a></p>
			<p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Rules for Performance Evaluation of Board of Directors.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Rules for Performance Evaluation of Board of Directors</a></p>
      <p v-else><a href="../../static/files/董事會績效評估辦法.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">董事會績效評估辦法</a></p>
      <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Rules Governing Financial and Business Matters Between this Corporation and its Affiliated Enterprises.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Rules Governing Financial and Business Matters Between this Corporation and its Affiliated Enterprises</a></p>
      <p v-else><a href="../../static/files/關係人相互間財務業務相關作業規範.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">關係人相互間財務業務相關作業規範</a></p>
			</div>
              </div></div></div>
              <div ref="top7" id="top7" class="about-box-01">  <!--公司治理運作情形 -->
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_07")}}</h3>
      <br />
        <h4>{{$t("investor_249")}}</h4>
        <p>{{$t("investor_250")}}<br>
      </p><br />
     <!-- <p>{{$t("investor_251")}}<br />
        <div class="table-responsive">
        <table class="table-bordered" border="1" cellspacing="5" cellpadding="5" style="width:100%;">
					<tr><td>{{$t("investor_252")}}</td></tr>
					<tr><td>{{$t("investor_253")}}</td></tr>
					<tr><td>{{$t("investor_254")}}<br />
                        {{$t("investor_255")}}<br />
                        {{$t("investor_256")}}<br />
                        {{$t("investor_257")}}<br />
          </td></tr>
				</table></div>
        <div class="table-responsive">
        <table class="table-bordered" border="1" cellspacing="5" cellpadding="5" style="width:100%;">
					<tr><td rowspan="2">{{$t("investor_258")}}</td><td rowspan="2">{{$t("investor_259")}}</td><td rowspan="2">{{$t("investor_260")}}</td><td colspan ="2">{{$t("investor_261")}}</td><td rowspan="2">{{$t("investor_262")}}</td><td rowspan="2">{{$t("investor_263")}}</td></tr>
					<tr><td>{{$t("investor_264")}}</td><td>{{$t("investor_265")}}</td></tr>
          <tr><td>1</td><td>{{$t("investor_266")}}</td><td>{{$t("investor_274")}}</td><td>{{$t("investor_282")}}</td><td>{{$t("investor_282")}}</td><td>{{$t("investor_289")}}</td><td rowspan ="8">{{$t("investor_291")}}</td></tr>
					<tr><td>2</td><td>{{$t("investor_267")}}</td><td>{{$t("investor_275")}}</td><td>{{$t("investor_283")}}</td><td>{{$t("investor_283")}}</td><td>{{$t("investor_289")}}</td></tr>
          <tr><td>3</td><td>{{$t("investor_268")}}</td><td>{{$t("investor_276")}}</td><td>{{$t("investor_284")}}</td><td>{{$t("investor_284")}}</td><td>{{$t("investor_289")}}</td></tr>
          <tr><td>4</td><td>{{$t("investor_269")}}</td><td>{{$t("investor_277")}}</td><td>{{$t("investor_285")}}</td><td>{{$t("investor_285")}}</td><td>{{$t("investor_289")}}</td></tr>
          <tr><td>5</td><td>{{$t("investor_270")}}</td><td>{{$t("investor_278")}}</td><td>{{$t("investor_286")}}</td><td>{{$t("investor_286")}}</td><td>{{$t("investor_289")}}</td></tr>
          <tr><td>6</td><td>{{$t("investor_271")}}</td><td>{{$t("investor_279")}}</td><td>{{$t("investor_287")}}</td><td>{{$t("investor_287")}}</td><td>{{$t("investor_289")}}</td></tr>
          <tr><td>7</td><td>{{$t("investor_272")}}</td><td>{{$t("investor_280")}}</td><td>{{$t("investor_288")}}</td><td>{{$t("investor_288")}}</td><td>{{$t("investor_289")}}</td></tr>
          <tr><td>8</td><td>{{$t("investor_273")}}</td><td>{{$t("investor_281")}}</td><td>{{$t("investor_288")}}</td><td>{{$t("investor_288")}}</td><td>{{$t("investor_290")}}</td></tr>
				</table></div><br />
      </p>-->
      <p>
        <h4>{{$t("investor_292")}}</h4>
        <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/The state of operation of corporate governance and the differences from the Corporate Governance Best Practice Principles for TWSE TPEx Listed Companies and the reasons therefo.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">{{$t("investor_293")}}</a></p>
        <p v-else><a href="../../static/files/114年公司治理運作情形.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">{{$t("investor_293")}}</a></p>
       <br />
      </p>
			</div>
              </div></div></div>
<div ref="top8" id="top8" class="about-box-01">  <!--內部稽核組織及運作 -->
  <div class="left">
    <div class="titleBox">
        <div class="description">
			<h3>{{$t("investor_08")}}</h3>
      <br />
        <h4>{{$t("investor_590")}}</h4>
        <p>{{$t("investor_591")}}</p>
<br>
        <h4>{{$t("investor_592")}}</h4>
        <p>{{$t("investor_593")}}</p>
        <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
           <img src="../assets/images/05.內部稽核組織_EN.jpg"  width="100%" height="100%" />
                  </span><span v-else>
                  <img src="../assets/images/05.內部稽核組織.jpg" width="100%" height="100%"/>
            </span>

        <h4>{{$t("investor_594")}}</h4>

							<p>{{$t("investor_595")}}</p>
							<p>{{$t("investor_596")}}</p>
							<p>{{$t("investor_597")}}</p>
							<p>{{$t("investor_598")}}</p>

              <br>
        <h4>{{$t("investor_599")}}</h4>

							<p>{{$t("investor_600")}}</p>
              <p>{{$t("investor_609")}}</p>



			</div>
              </div></div></div>

              <div ref="top9" id="top9" class="about-box-01">  <!--與獨立董事溝通情形 -->
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_09")}}</h3>
      <br />

      <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
        <h4>(1)	The Communication between Independent Directors and the Chief Internal Auditor</h4>
        <p>The Chief Internal Auditor of the company, in addition to presenting reports at each board meeting and audit committee meeting, holds a separate reporting meeting with the independent directors once every quarter. During this meeting, communication takes place based on the specific reporting topics assigned by the independent directors or an overview of the quarterly audit findings.</p>
      <p></p>
      <div class="table-responsive">
      <table class="table-bordered" border="1" cellspacing="5" cellpadding="5" style="width:100%;">
  <tr>
    <td width="95" valign="top"><p>Date</p></td>
    <td width="236" valign="top"><p>Attendees</p></td>
    <td width="232" valign="top"><p>Summary of Communications</p></td>
    <td width="128" valign="top"><p>Result of Communications</p></td>
  </tr>
  <tr>
    <td width="95" valign="top"><p>2024.3.11</p></td>
    <td width="236" valign="top"><p>
      Shih-Fang Chiu, Independent Director<br />
Shih-Chen Jao, Independent Director<br />
Sheng-Chi Wu, Independent Director (attended via video conference)<br />
Yu-Juan Hsiao, Independent Director<br />
Hsin-Ni Tsai, Chief Internal Audito<br />
You-Jun Huang, Deputy Account Manager
    </p></td>
    <td width="232" valign="top">
      1.Report on the execution status of the audit plan<br />
      2.Report on the status of project audits
    </td>
    <td width="128" valign="top">
     Approval without objection.
    </td>
  </tr>
  <tr>
    <td width="95" valign="top"><p>2024.5.8</p></td>
    <td width="236" valign="top">Shih-Fang Chiu, Independent Director<br />
Shih-Chen Jao, Independent Director<br />
Sheng-Chi Wu, Independent Director<br />
Yu-Juan Hsiao, Independent Director<br />
Hsin-Ni Tsai, Chief Internal Auditor<br />
You-Jun Huang, Deputy Account Manager
</td>
    <td width="232" valign="top">1.Report on the execution status of the audit plan<br />
2.Report on the status of project audits<br />
3.Report on recent regulatory updates
    </td>
    <td width="128" valign="top"><p>Approval without objection.</p></td>
  </tr>
  <tr>
    <td width="95" valign="top"><p>2024.7.9</p></td>
    <td width="236" valign="top">Shih-Fang Chiu, Independent Director<br />
Shih-Chen Jao, Independent Director<br />
Sheng-Chi Wu, Independent Director<br />
Yu-Juan Hsiao, Independent Director (attended via video conference)<br />
Hsin-Ni Tsai, Chief Internal Auditor
</td>
    <td width="232" valign="top">1.Explanation of matters assigned in previous meetings<br />
2.Report on the execution status of the audit plan<br />
3.Report on the status of project audits
    </td>
    <td width="128" valign="top"><p>Approval without objection.</p></td>
  </tr>
  <tr>
    <td width="95" valign="top"><p>2024.11.6</p></td>
    <td width="236" valign="top">Shih-Fang Chiu, Independent Director<br />
Shih-Chen Jao, Independent Director<br />
Sheng-Chi Wu, Independent Director<br />
Yu-Juan Hsiao, Independent Director<br />
Hsin-Ni Tsai, Chief Internal Auditor<br />
You-Jun Huang, Deputy Account Manager
</td>
    <td width="232" valign="top">1.Report on the execution status of the audit plan<br />
2.Anticipated items for the 2025 audit plan
</td>
    <td width="128" valign="top"><p>Incorporating the directors' recommendations into the audit plan was approved without objection</p></td>
  </tr>
</table></div>
    </span>
      <span v-else>
        <h4>(1)	內部稽核主管與獨立董事之溝通</h4>
        <p>本公司稽核主管除每次董事會、審計委員會皆列席報告外，並在每季進行一次與獨立董事單獨報告會議，依據獨立董事指定報告項目或每季查核情形進行溝通。</p>
        <div class="table-responsive">
        <table class="table-bordered" border="1" cellspacing="5" cellpadding="5" style="width:100%;">
  <tr>
    <td><p align="center">日期 </p></td>
    <td width="154"><p align="center">出席人員 </p></td>
    <td width="198"><p align="center">溝通事項 </p></td>
    <td width="100"><p align="center">溝通結果 </p></td>
  </tr>
  <tr>
      <td>114/03/13</td>
      <td width="154"><p>獨立董事邱士芳<br />獨立董事饒世湛<br />獨立董事吳昇奇<br />獨立董事蕭玉娟<br />稽核長蔡欣霓<br />副理吳亭瑩<br />副主任黃有君</p></td>
      <td width="198">1.稽核計畫執行情形報告<br />2.113年度海外子公司實地查核報告</td>
      <td width="100">無異議照案通過</td>
  </tr>

  <tr>
      <td>114/05/07</td>
      <td width="154"><p>獨立董事邱士芳<br />獨立董事饒世湛<br />獨立董事吳昇奇<br />獨立董事蕭玉娟<br />副理吳亭瑩<br /></p></td>
      <td width="198">1.稽核計畫執行情形報告<br />2.進行災害復原演練排程、重大客訴報告</td>
      <td width="100">無異議照案通過</td>
  </tr>

  <tr>
      <td>114/08/12</td>
      <td width="154"><p>獨立董事邱士芳<br />獨立董事饒世湛<br />獨立董事吳昇奇<br />獨立董事蕭玉娟(視訊出席)<br />副理吳亭瑩<br /></p></td>
      <td width="198">1.稽核計畫執行情形報告<br />2.進行災害復原演練排程、供應商評鑑修訂進度及門市管理作業報告</td>
      <td width="100">無異議照案通過</td>
  </tr>

  <tr>
      <td>114/11/11</td>
      <td width="154"><p>獨立董事邱士芳<br />獨立董事饒世湛<br />獨立董事吳昇奇<br />獨立董事蕭玉娟<br />副理吳亭瑩<br /></p></td>
      <td width="198">1.稽核計畫執行情形報告<br />2.115年度災害復原演練排程、供應商評鑑修訂進度及近期網路新聞報告</td>
      <td width="100">無異議照案通過</td>
  </tr>

</table></div>
      </span>
      <br />
      <h4>{{$t("investor_365")}}</h4>
        <p> {{$t("investor_366")}}</p>
      <p>
        <div class="table-responsive">
        <table class="table-bordered" border="1" cellspacing="4" cellpadding="4" style="width:100;">
						<tr style="text-align: center"><td>{{$t("investor_061")}}</td><td width="22%">{{$t("investor_371")}}</td><td>{{$t("investor_372")}}</td><td>{{$t("investor_373")}}</td></tr>
						<tr><td>{{$t("investor_367")}}</td><td>{{$t("investor_030")}} {{$t("investor_031")}}<br>{{$t("investor_030")}} {{$t("investor_033")}}<br>{{$t("investor_030")}} {{$t("investor_034")}}<br>{{$t("investor_030")}} {{$t("investor_401")}} <br>{{$t("investor_374")}}<br>{{$t("investor_370")}}</td><td>{{$t("investor_375")}}</td><td>{{$t("investor_377")}}</td></tr>
						<tr><td>{{$t("investor_368")}}</td><td>{{$t("investor_030")}} {{$t("investor_031")}}<br>{{$t("investor_030")}} {{$t("investor_033")}}<br>{{$t("investor_030")}} {{$t("investor_034")}}<br>{{$t("investor_030")}} {{$t("investor_032")}}<br>{{$t("investor_369")}}<br>{{$t("investor_370")}}</td><td>{{$t("investor_376")}}</td><td>{{$t("investor_378")}}</td></tr>
					</table></div>
             </p>
			</div>
              </div></div></div>
              <div ref="top10" id="top10" class="about-box-01"><!--誠信經營落實情形 -->
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_10")}}</h3>
      <br />
        <h4>{{$t("investor_388")}}</h4>
        <p>{{$t("investor_390")}}</p><br />
        <h4>{{$t("investor_391")}}</h4>
             <p>{{$t("investor_392")}}
             </p><br />
        <h4>{{$t("investor_393")}}</h4>
        <p> {{$t("investor_394")}}</p>
             <br />
        <h4>{{$t("investor_397")}}</h4>
        <p> {{$t("investor_398")}}<br />

        </p><br />

        <h4>{{$t("investor_395")}}</h4>
        <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Ethical Corporate Management deviations from the Ethical Corporate Management Best Practice Principles for TWSE TPEx-listed Companies and Reasons.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Ethical Corporate Management deviations from the Ethical Corporate Management Best Practice Principles for TWSE TPEx-listed Companies and Reasons</a></p>
        <p v-else><a href="../../static/files/114履行誠信經營情形及與上市上櫃公司誠信經營守則差異情形及原因.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">履行誠信經營情形及與上市上櫃公司誠信經營守則差異情形及原因</a></p>
        <br />


              <h4>{{$t("investor_427")}}</h4>
              <p>{{$t("investor_428")}}</p><br><br>
              <h5>{{$t("investor_429")}}</h5>
              <p>{{$t("investor_430")}}obey.laws@8way.com.tw<br>
              {{$t("investor_431")}}</p>
              <br><br>
              <h5>{{$t("investor_432")}}</h5>
              <p>{{$t("investor_433")}}<br>
              {{$t("investor_434")}}<br>
              {{$t("investor_435")}}</p>
              <br><br>
              <h5>{{$t("investor_436")}}</h5>
              <p>{{$t("investor_437")}}<br>{{$t("investor_438")}}</p> <br><br>


              <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
                <a  href="../../static/files/Mechanism for violation of code of conduct.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Reporting Mechanism for Violation of Code of Conduct</a> <br><br>
              <a  href="../../static/files/Whistleblowing letter Download.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">{{$t("investor_439")}}</a>
              <br><br>
            </p>

              <p v-else>
              <a href="../../static/files/誠信違反檢舉作業辦法.pdf"  target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">誠信違反檢舉作業辦法</a>  <br><br>
              <a href="../../static/files/檢舉表單下載.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">{{$t("investor_439")}}</a></p>

              <br>

			</div>
              </div></div></div>
              <div ref="top11" id="top11" class="about-box-01"><!--防範內線交易管理落實情形 -->
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_11")}}</h3>
      <br /><p>
        {{$t("investor_452")}}<br>
        {{$t("investor_453")}}<br>
        {{$t("investor_454")}}
      </p><br />
      <p style="color:red;"><b>{{$t("investor_455")}}</b></p>

			</div>
              </div></div></div>
              <div ref="top21" id="top21" class="about-box-01"><!--智慧財產管理 -->
              <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_13")}}</h3>
      <br />
      <p>
        <h4>{{$t("investor_616")}}</h4>
        <p>{{$t("investor_617")}}</p>
        <a href="../../static/files/114智慧財產管理計畫.pdf"  target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">智慧財產管理計劃</a><br><br>     

        <h4>{{$t("investor_618")}}</h4>
        <p >{{$t("investor_619")}}</p>
        <p style="text-indent:2ch;">{{$t("investor_620")}}</p>
        <p style="text-indent:2ch;">{{$t("investor_621")}}</p>
        <p >{{$t("investor_622")}}</p> 
        <br />
        <p >{{$t("investor_623")}}</p>
      </p><br />

			</div>
              </div></div></div>
              <div ref="top12" id="top12" class="about-box-01"><!--資訊安全 -->
            <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_12")}}</h3>
      <br />
        <h4>{{$t("investor_440")}}</h4>
        <p>{{$t("investor_441")}}</p>
        <br><br><h4>{{$t("investor_548")}}</h4>
        <p>{{$t("investor_549")}}
        </p><img src="../assets/images/ISSGS.jpg" width="100%" height="100%">
        <br><br><h4>{{$t("investor_442")}}</h4>
        <p> {{$t("investor_443")}}<br>
          {{$t("investor_444")}}</p>
        <br><br><h4>{{$t("investor_445")}}</h4>
       <p> {{$t("investor_446")}}</p>
        <br><br><h4>{{$t("investor_447")}}</h4>
        <p>{{$t("investor_448")}}<br>
        <br><br><h4>{{$t("investor_450")}}</h4>
        <p>{{$t("investor_451")}}</p>
        <br><br><h4>{{$t("investor_624")}}</h4>
        <p>{{$t("investor_625")}}</p>
      <br />


			</div>
              </div></div></div>
              <div ref="top22" id="top22" class="about-box-01"><!--個人資料保護 -->
              <div class="left">
              <div class="titleBox ">
                <div class="description">
			<h3>{{$t("investor_14")}}</h3>
      <br /><p>
        <h4>{{$t("investor_626")}}</h4>
        <p>{{$t("investor_627")}}</p>  

        <h4>{{$t("investor_628")}}</h4>
        <p >{{$t("investor_629")}}</p>
        <p style="text-indent:2ch;">{{$t("investor_630")}}</p>
        <p style="text-indent:2ch;">{{$t("investor_631")}}</p>
        <p style="text-indent:2ch;">{{$t("investor_632")}}</p>
        <p style="text-indent:2ch;">{{$t("investor_633")}}</p>  
        <a href="../../static/files/114個人資料檔案安全維護計畫.pdf"  target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">個人資料檔案安全維護計畫</a><br><br>     
        <br />
        <h4>{{$t("investor_634")}}</h4>
        <p >{{$t("investor_635")}}</p>
        <p >{{$t("investor_636")}}</p>
        <br />
        <h4>{{$t("investor_637")}}</h4>
        <p >{{$t("investor_638")}}</p>
        <p >{{$t("investor_639")}}</p>  

      </p><br />



			</div>
              </div></div></div>
            </span>


          </ul>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from "./config/api";
  import vueTabSelect from "./default/vue-tab-select";
  export default {
    name: 'Investor',
   metaInfo() {
      const baseUrl = 'https://www.8way.com.tw';
      let ogTitle = '';
      let ogDescription = '';
      let ogImage = '';
      let schemaData = null;
      let id = this.$route.params.ids;

      switch(id){
        case '0701':
          ogTitle = '八方雲集 - 財務資訊 Financials';
          ogDescription = '查看八方雲集的財務報表、營收資訊、每股盈餘等完整財務數據,掌握公司經營狀況。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": `${baseUrl}/investor/0701#collection`,
            "url": `${baseUrl}/investor/0701`,
            "name": "財務資訊｜投資人專區",
            "description": "八方雲集投資人專區－財務資訊頁，彙整每月營收、財務報表與重要財務比率等投資人關注資訊。",
            "inLanguage": "zh-TW",
            "isPartOf": {
              "@id": `${baseUrl}/#website`
            },
            "about": {
              "@id": `${baseUrl}/#organization`
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首頁",
                  "item": `${baseUrl}/`
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "投資人專區",
                  "item": `${baseUrl}/investor`
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "財務資訊",
                  "item": `${baseUrl}/investor/0701`
                }
              ]
            },
            "mainEntity": {
              "@type": "ItemList",
              "name": "財務資訊內容分類",
              "itemListOrder": "http://schema.org/ItemListOrderAscending",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0701#top13`,
                    "url": `${baseUrl}/investor/0701#top13`,
                    "name": "每月營收",
                    "inLanguage": "zh-TW",
                    "description": "八方雲集每月營收相關資訊與公告。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0701#top14`,
                    "url": `${baseUrl}/investor/0701#top14`,
                    "name": "財務報表",
                    "inLanguage": "zh-TW",
                    "description": "年度及季度財務報表彙整。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0701#top15`,
                    "url": `${baseUrl}/investor/0701#top15`,
                    "name": "重要財務比率",
                    "inLanguage": "zh-TW",
                    "description": "重要財務比率與相關指標說明。"
                  }
                }
              ]
            }
          };
          break;
        case '0702':
          ogTitle = '八方雲集 - 股東專區 Shareholder Service';
          ogDescription = '提供八方雲集股東會資訊、股利政策、股票資訊等服務,保障股東權益。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": `${baseUrl}/investor/0702#collection`,
            "url": `${baseUrl}/investor/0702`,
            "name": "股東專區｜投資人專區",
            "description": "八方雲集投資人專區－股東專區，提供股東會資訊、股利政策、股票資訊等服務。",
            "inLanguage": "zh-TW",
            "isPartOf": {
              "@id": `${baseUrl}/#website`
            },
            "about": {
              "@id": `${baseUrl}/#organization`
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首頁",
                  "item": `${baseUrl}/`
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "投資人專區",
                  "item": `${baseUrl}/investor`
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "股東專區",
                  "item": `${baseUrl}/investor/0702`
                }
              ]
            },
            "mainEntity": {
              "@type": "ItemList",
              "name": "股東專區內容分類",
              "itemListOrder": "http://schema.org/ItemListOrderAscending",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0702#top16`,
                    "url": `${baseUrl}/investor/0702#top16`,
                    "name": "主要股東",
                    "inLanguage": "zh-TW",
                    "description": "八方雲集主要股東持股資訊。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0702#top17`,
                    "url": `${baseUrl}/investor/0702#top17`,
                    "name": "股東會及年報",
                    "inLanguage": "zh-TW",
                    "description": "股東會開會通知、議事手冊及年報等資料。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0702#top18`,
                    "url": `${baseUrl}/investor/0702#top18`,
                    "name": "股利政策",
                    "inLanguage": "zh-TW",
                    "description": "歷年股利分配資訊及政策說明。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 4,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0702#top19`,
                    "url": `${baseUrl}/investor/0702#top19`,
                    "name": "法說會",
                    "inLanguage": "zh-TW",
                    "description": "法人說明會簡報及影片連結。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 5,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0702#top20`,
                    "url": `${baseUrl}/investor/0702#top20`,
                    "name": "重大訊息與公告",
                    "inLanguage": "zh-TW",
                    "description": "公司重大訊息及公告資訊。"
                  }
                }
              ]
            }
          };
          break;
        case '0703':
          ogTitle = '八方雲集 - 公司治理 Corporate Governance';
          ogDescription = '了解八方雲集的公司治理架構、董事會資訊、內部稽核制度等,展現企業透明度與責任。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
          schemaData = {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": `${baseUrl}/investor/0703#collection`,
            "url": `${baseUrl}/investor/0703`,
            "name": "公司治理｜投資人專區",
            "description": "八方雲集投資人專區－公司治理，展現董事會資訊、內部稽核制度等企業透明度與責任。",
            "inLanguage": "zh-TW",
            "isPartOf": {
              "@id": `${baseUrl}/#website`
            },
            "about": {
              "@id": `${baseUrl}/#organization`
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首頁",
                  "item": `${baseUrl}/`
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "投資人專區",
                  "item": `${baseUrl}/investor`
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "公司治理",
                  "item": `${baseUrl}/investor/0703`
                }
              ]
            },
            "mainEntity": {
              "@type": "ItemList",
              "name": "公司治理內容分類",
              "itemListOrder": "http://schema.org/ItemListOrderAscending",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top1`,
                    "url": `${baseUrl}/investor/0703#top1`,
                    "name": "組織架構",
                    "inLanguage": "zh-TW",
                    "description": "八方雲集組織架構圖。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top2`,
                    "url": `${baseUrl}/investor/0703#top2`,
                    "name": "董事會",
                    "inLanguage": "zh-TW",
                    "description": "董事會成員組成及運作資訊。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top3`,
                    "url": `${baseUrl}/investor/0703#top3`,
                    "name": "審計委員會",
                    "inLanguage": "zh-TW",
                    "description": "審計委員會成員及職責說明。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 4,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top4`,
                    "url": `${baseUrl}/investor/0703#top4`,
                    "name": "薪酬委員會",
                    "inLanguage": "zh-TW",
                    "description": "薪酬委員會成員及運作資訊。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 5,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top5`,
                    "url": `${baseUrl}/investor/0703#top5`,
                    "name": "風險管理組織架構",
                    "inLanguage": "zh-TW",
                    "description": "風險管理架構與運作機制。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 6,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top6`,
                    "url": `${baseUrl}/investor/0703#top6`,
                    "name": "公司制度規範",
                    "inLanguage": "zh-TW",
                    "description": "公司各項制度規範及章程。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 7,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top7`,
                    "url": `${baseUrl}/investor/0703#top7`,
                    "name": "公司治理運作情形",
                    "inLanguage": "zh-TW",
                    "description": "公司治理評鑑及運作狀況。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 8,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top8`,
                    "url": `${baseUrl}/investor/0703#top8`,
                    "name": "內部稽核組織及運作",
                    "inLanguage": "zh-TW",
                    "description": "內部稽核單位組織及運作說明。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 9,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top9`,
                    "url": `${baseUrl}/investor/0703#top9`,
                    "name": "與獨立董事溝通情形",
                    "inLanguage": "zh-TW",
                    "description": "管理階層與獨立董事溝通紀錄。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 10,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top10`,
                    "url": `${baseUrl}/investor/0703#top10`,
                    "name": "誠信經營落實情形",
                    "inLanguage": "zh-TW",
                    "description": "誠信經營政策及執行狀況。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 11,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top11`,
                    "url": `${baseUrl}/investor/0703#top11`,
                    "name": "防範內線交易管理落實情形",
                    "inLanguage": "zh-TW",
                    "description": "防範內線交易管理措施說明。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 12,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top12`,
                    "url": `${baseUrl}/investor/0703#top12`,
                    "name": "資訊安全",
                    "inLanguage": "zh-TW",
                    "description": "資訊安全管理政策與措施。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 13,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top21`,
                    "url": `${baseUrl}/investor/0703#top21`,
                    "name": "智慧財產管理",
                    "inLanguage": "zh-TW",
                    "description": "智慧財產管理。"
                  }
                },
                {
                  "@type": "ListItem",
                  "position": 13,
                  "item": {
                    "@type": "WebPage",
                    "@id": `${baseUrl}/investor/0703#top22`,
                    "url": `${baseUrl}/investor/0703#top22`,
                    "name": "個人資料保護",
                    "inLanguage": "zh-TW",
                    "description": "個人資料保護。"
                  }
                }
              ]
            }
          };
          break;
        default:
          ogTitle = '八方雲集 - 投資人專區';
          ogDescription = '八方雲集投資人專區,提供財務資訊、股東服務及公司治理相關資訊。';
          ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';
      }

      const meta = [
        { property: 'og:title', content: ogTitle },
        { property: 'og:description', content: ogDescription },
        { property: 'og:image', content: ogImage },
        { property: 'og:url', content: typeof window !== 'undefined' ? window.location.href : '' },
        { property: 'og:type', content: 'website' }
      ];

      const script = [];
      if (schemaData) {
        script.push({
          type: 'application/ld+json',
          json: schemaData
        });
      }

      return {
        title: ogTitle,
        meta: meta,
        script: script
      };
    },
    data () {
      return {
        name:'',
        nameEN:'',
        paramId: '',
        typeList: [],
        investorList: [],
        bannerImage: '',
        refname:'top1',
        menuList: [
          { name: "investor_01", code: 'top1' },
          { name: "investor_02", code: 'top2' },
          { name: "investor_02", code: 'top3' },
          { name: "investor_03", code: 'top4' },
          { name: "investor_04", code: 'top5' },
          { name: "investor_05", code: 'top6' },
          { name: "investor_06", code: 'top7' },
          { name: "investor_07", code: 'top8' },
          { name: "investor_08", code: 'top9' },
          { name: "investor_09", code: 'top10' },
          { name: "investor_10", code: 'top10' },
          { name: "investor_11", code: 'top11' },
          { name: "investor_12", code: 'top12' },
          { name: "investor_13", code: 'top21' },
          { name: "investor_14", code: 'top22' },         
        ],
        refname2:'top13',
        menuList2: [
          { name: "investor_21", code: 'top13' },
          { name: "investor_22", code: 'top14' },
          { name: "investor_23", code: 'top15' },
        ],
        refname3:'top16',
        menuList3: [
          { name: "investor_24", code: 'top16' },
          { name: "investor_25", code: 'top17' },
          { name: "investor_26", code: 'top18' },
          { name: "investor_27", code: 'top19' },
          { name: "investor_28", code: 'top20' },
        ],
        locale:'tw',
        yearSearch: "2025"
      }
    },
    mounted () {
      this.locale=sessionStorage.getItem('lang');
      this.paramId = this.$route.params.ids;
      this.GetTypeList();
      this.locale=sessionStorage.getItem('lang')
      if(this.$route.params.id){
        this.linktop(this.$route.params.id)
      }
      this.$nextTick(()=>{
        this.initSwiper();
      })
    },
    methods:{
      linktop(refid){
        const { top } = $(`#${refid}`).offset();
        $('html , body').animate({scrollTop: top}, 'slow');
        //document.documentElement.scrollTop = this.$refs[refid].offsetTop
        this.refname = refid
      },
      tabtitle(id, name, img, nameEN){
        this.$router.push({ name: 'Investor', params: { ids: id }});
        this.paramId = id;
        this.name = name;
        this.bannerImage = img;
        this.nameEN = nameEN;
        this.GetTypeList();
      },
      changeType(e){
        const [ choose ] = this.typeList.filter((item) => { return this.paramId === item.id });
        this.tabtitle(choose.id, choose.name, choose.bannerImage, choose.nameEN);
      },
      GetTypeList:function(){
        this.$fetch(API.getInvestorType).then((response) => {
          if(response.code === 200){
            this.typeList = response.data;
            if(this.paramId){
              this.typeList.forEach(item => {
                if(this.paramId === item.id){
                  this.name = item.name;
                  this.nameEN = item.nameEN;
                  this.bannerImage = item.bannerImage;
                }
              })
            }else {
              const [ type = {} ] = this.typeList;
              this.paramId = type.id;
              this.name = type.name;
              this.bannerImage = type.bannerImage;
              this.nameEN = type.nameEN;
            }
            this.GetInvestorList();
          }
        });
      },
      GetInvestorList:function(){
        this.$post(API.getInvestorList,{
          "typeId": this.paramId
        }).then((response) => {
          if(response.code === 200){
            this.investorList = response.data;
          }
        });
      },
      toDetail: function (id){
        this.$router.push({ name: 'InvestorDetails', params: { id: id }});
      }
    },
    watch: {
      $route: {
        handler() {
          this.paramId = this.$route.params.ids;
          this.GetTypeList();
        },
        deep: true,
      }
    },
    components:{
      'vue-tab-select': vueTabSelect
    },
    computed: {
    selectedYear() {
      return this.yearSearch;
    },
  },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
}

.table-responsive table {
    width: 100%;
    white-space: nowrap;
}
  ul{
    padding-left:0;
  }
  .product{
    width: 100%;
    height:auto;
    background:#fafafa;
 /*  .top-img{
     width: 100%;
     height: 354px;
     position: relative;
     background:#fafafa url("../assets/images/product-banner.png") no-repeat top;
     background-size: 100% 100%;;
     .bg-img{
       position: absolute;
       width: 100%;
     }
     img{
      !* width: 100%;
       height: 100%;
       background-size: cover;*!
     }
     .info-box{
       width: 100%;
       max-width: 1392px;
       padding: 0 20px 0 9.339%;
       margin: 0 auto;
       &:after{
         content: "";
         display: block;
         clear: both;
       }
       .title-box{
         max-width: 54%;
         float: left;
         padding-top: 60px;
         text-align: right;
         h2{
           color: #FFFFFF;
           font-size: 68px;
           font-style: italic;
           font-weight: 900;
           letter-spacing: 0;
           line-height: 75px;
           margin-bottom: 15px;
         }
         h3{
           color: #FFFFFF;
           font-size: 36px;
           letter-spacing: 1px;
           line-height: 42px;
           margin: 0;
         }
       }
       .bannerImage{
         float: right;
         width: 46%;
         padding-top: 25px;
         img{
           width: 100%;
         }
       }
     }
   }*/
  .bannerImage{
    width: 30%;
 /*   padding-top: 25px;
    float: right;*/
    position: absolute;
    right:15%;
    bottom:-5px;
       img{
         width: 100%;
       }
  }

  .product-main{
    width: 100%;
    height: 100%;
    background: #f9f9f9 url("../assets/images/product-contenBg.png") no-repeat center 100px;
    background-size: 100% auto;
    overflow: hidden;
    padding-top: 36px;
    padding-bottom: 140px;
  }
   .product-conten{
     max-width:1390px;
     padding: 0 20px;
     margin: 0 auto;
    .product-title{
      padding-bottom:40px;
      font-size: 14px;
      letter-spacing: 1.5px;
      text-align: left;
       a{
         color: #000;
         text-decoration: underline;
       }
      em{
        padding: 0 4px;
      }
      span,em{
        color: #9A928D;
      }
    }
    .nav{
      height: auto;
      width: 350px;
      border-radius: 20px;
      background-color: #FFFFFF;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
      padding:55px 48px 55px 44px;
      position: relative;
      float: left;
      h4,ul{
       width: 100%;
      }
      h4{
        font-size: 28px;
        font-weight: 500;
        letter-spacing: 2.1px;
        padding-bottom:8px;
      &.en-font-28{
         letter-spacing: 0px;
         font-family: 'Roboto Medium';
       }
      }
      a{
        color: #000;
        font-size: 18px;
        letter-spacing: 1.35px;
        cursor: pointer;
        display: block;
        &.active{
            color:red
          }
        &.en-font-18{
           letter-spacing: 0px;

         }
      }
     ul{
       li{
         padding: 25px 0;
         border-bottom:1px solid #e2e2e2;
         position: relative;
       }

     }
    .active{
      color: #CF0902;
      font-weight: 500;
      a{
        color: #CF0902;
      }
      .nav-line{
        height: 5px;
        width: 46px;
        display: inline-block;
        background-color: #CF0902;
        position: absolute;
        right: -63px;
        top: 36px;
      }
    }
      li:hover{
        color: #CF0902;
        font-weight: 500;
        a{
          color: #CF0902;
        }
      }
    }
    .investor-nav{
      height: auto;
      width: 100%;
      border-radius: 20px;
      background-color: #FFFFFF;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
      padding:35px 20px 25px 24px;
      position: relative;
      float: left;
      h4,ul{
       width: 100%;
      }
      h4{
        font-size: 28px;
        font-weight: 500;
        letter-spacing: 2.1px;
        padding-bottom:8px;
      &.en-font-28{
         letter-spacing: 0px;
         font-family: 'Roboto Medium';
       }
      }
      a{
        color: #000;
        font-size: 18px;
        letter-spacing: 1.35px;
        cursor: pointer;
        display: block;
        &.active{
            color:red
          }
        &.en-font-18{
           letter-spacing: 0px;

         }
      }
     ul{
       li{

         padding: 3px;/*次標與底線間距*/
         border-bottom:1px solid #e2e2e2;/*次標底線顏色*/
         position: relative;
       }
     }
    .active{
      color: #CF0902;
      font-weight: 500;
      a{
        color: #CF0902;
      }
      .nav-line{
        height: 5px;
        width: 46px;
        display: inline-block;
        background-color: #CF0902;
        position: absolute;
        right: -63px;
        top: 36px;
      }
    }
      li:hover{
        color: #CF0902;
        font-weight: 500;
        a{
          color: #CF0902;
        }
      }
    }
   }

    .product-show {
      width: calc(100% - 350px);
      height: auto;
      float: left;
      padding-left: 124px;

      .left{
      width: 100%;
      display: inline-block;
      box-sizing: border-box;
      padding-top: 10px;
      .description{
        margin-top: 27px;
        height: auto;
        max-width: 718px;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
        padding: 38px 15px 15px 15px;
        margin-left: 22px;
        p{
          width:100%;
          color: #2A1C15;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }
      }
    }
      ul {
        padding-left: 0;

        li {
          width: calc( (100% - 180px ) / 3);
          float: left;
          cursor: pointer;
          margin: 0 36px 50px;
          .img-box{
            position: relative;
          }
          .big-img-box {
            width: 100%;
            border-radius: 50%;
            border: 8px solid #fff;
            overflow: hidden;
            box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
            img {
              width: 100%;
              height: 100%;
              background-size: 100%;
            }
          }
          .small-img-box{
            width: 66px;
            height: 66px;
            border: solid 3px #fff;
            border-radius: 50%;
            overflow: hidden;
            background: #fff;
            position: absolute;
            right: 0;
            bottom: 19px;
            box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
            img{
              width: 100%;
            }
          }

          p {
            text-align: center;
            padding-top: 10px;
            font-size: 18px;
            letter-spacing: 0.9px;
            line-height: 42px;
            color: #000;
          }
          &:nth-child(3n + 1){
            clear: both;
          }
          &:nth-child(3n){
            margin-right: 0;
          }
        }
      }
    }
  }
  @media (max-width:1080px){

    .type-nav{
      margin-top: 10px;
      height: 100%;
    }
    .product{
      .product-main{
        background-image: url("../assets/images/product-bg-mobile.png");
      }
      .top-img{
        height: 187px;
        background-image: url("../assets/images/product-banner-mobile.png");
        background-size: 100% auto;
        background-color: #f9f9f9;
        background-repeat: no-repeat;
        .info-box{
          position: relative;
          height: 100%;
          .title-box{
            padding-top: 20px;
            position: static;
            float: left;
            h2{
              font-size: 24px;
              letter-spacing: 0;
              line-height: 28px;
              margin-bottom: 9px;

            }
            h3{
              font-size: 20px;
              letter-spacing: 0.56px;
              line-height: 28px;
            }
          }
          .bannerImage{
            width: auto;
            height: 66%;
            position: absolute;
            bottom: 12px;
            right: 20px;
            text-align: right;
            img{
              width: auto;
              height: 100%;
            }
          }
        }
      }
       .product-main{
         padding:0 20px;
         padding-top: 20px;

       }
       .product-conten{
         padding: 0;
         .product-title{
           padding-bottom: 20px;
         }
      .investor-nav{
      height: auto;
      width: 100%;
      border-radius: 20px;
      background-color: #FFFFFF;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
      padding:25px 28px 25px 24px;
      position: relative;
      float: left;
      h4,ul{
       width: 100%;
      }
      h4{
        font-size: 28px;
        font-weight: 500;
        letter-spacing: 2.1px;
        padding-bottom:8px;
      &.en-font-28{
         letter-spacing: 0px;
         font-family: 'Roboto Medium';
       }
      }
      a{
        color: #000;
        font-size: 18px;
        letter-spacing: 1.35px;
        cursor: pointer;
        display: block;
        &.active{
            color:red
          }
        &.en-font-18{
           letter-spacing: 0px;

         }
      }
     ul{
       li{
         width: 100%;/*標題文字的寬度*/
         margin:5px;
         padding: 3px;/*次標間距*/
         border-bottom:1px solid #e2e2e2;/*次標底線顏色*/
         position: relative;
       }
     }
    .active{
      color: #CF0902;
      font-weight: 500;
      a{
        color: #CF0902;
      }
      .nav-line{
        height: 5px;
        width: 46px;
        display: inline-block;
        background-color: #CF0902;
        position: absolute;
        right: -63px;
        top: 36px;
      }
    }
      li:hover{
        color: #CF0902;
        font-weight: 500;
        a{
          color: #CF0902;
        }
      }
    }
       }

     .product-show{
       width: 100%;
       padding: 30px 0;
       ul{
         padding: 0 5px;
         li{
           width: 50%;
           padding: 0 25px;
           margin: 0 0 25px 0;
           .img-box{
             margin-bottom: 2px;
           }
           .big-img-box{
             border-width: 5px;
             width: 100%;
             margin: 0;
           }
           p{
             font-size: 15px;
             letter-spacing: 0.5px;
             line-height: 28px;
             padding-top: 0;
           }
           &:nth-child(3n+1) {
             clear: inherit;
           }
           &:nth-child(2n+1) {
             clear: both;
           }
         }
       }
     }
    }
  }

  .about-box-01{
    width: 100%;
    height: auto;
    overflow: hidden;
    .titleBox {
      h2{
        margin-bottom: 13px;
      }
    }
    .left{
      width: 51.3888%;
      display: inline-block;
      box-sizing: border-box;
      padding-top: 126px;
      .description{
        margin-top: 27px;
        height: auto;
        max-width: 718px;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
        padding: 58px 75px 63px 78px;
        margin-left: 22px;
        p{
          width:100%;
          color: #2A1C15;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }
      }
    }
    .right{
      width: 43.6805%;
      display: inline-block;
      vertical-align: top;
      padding: 57px 32px 0 38px;
      &.pc_hide{
        display: none;
      }
      .img{
        max-width: 560px;
        height: auto;
        img{
          width: 100%;
          height: 100%;
          background-size: 100%;
        }
      }
    }
  }
  #top1{
      .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
    }
  #top2{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
  #top3{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
  #top4{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
  #top5{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
  #top6{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
  #top7{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
  #top8{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
  #top9{
      .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
    }
    #top10{
      .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
    }
    #top11{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
    #top21{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
    #top22{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
  #top12{
    .left{
        margin-top: 25px;
        float: none;
        .description{
          margin-left: 0;
          margin-top: 10px;
          max-width: 100%;
        }
      }
      .right{
        float: none;
        padding: 0;
        margin-bottom: 0;
      }
      .titleBox {
        h2{
          margin: 0;
        }
      }
  }
  .table-bordered{

          width:100%;
          color: #2A1C15;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;


  }
  .about-box-02{
    width: 100%;
    box-sizing: border-box;
    min-height: 660px;
    border-radius: 30px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    margin-left:33px;
    overflow: visible;
    &:after{
      content: "";
      display: block;
      clear: both;
    }
    .left{
      width: 57.5935%;
      display: inline-block;

      .img{
        max-width: 785px;
        height: 424px;
        margin-top:-76px;
        margin-left:-33px;
          img{
            width: 100%;
            background-size: 100%;
          }
      }
      .description{
        max-width: 718px;
        margin: 72px auto 72px;
        padding-left: 22px;

        p{
          color: #000000;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }

      }
    }
    .right{
      width: 45.6346%;
      display: inline-block;
      vertical-align: top;
      padding-top: 45px;

      margin-right: -62px;
      .titleBox {
        max-width: 515px;
        margin: 0 auto;
        h2{
          padding-left: 132px;
        }
      }
      .img{
        height: 324px;
        position: relative;
        top: 32px;
        right: 19px;
           img{
             width: 100%;
             background-size: 100%;
           }
      }
      .img-box{
        position: relative;
         margin-top:32px;

        .color-bg{
          height: 285px;
          width: 100%;
          max-width: 614px;
          border-radius: 30px;
          background-color: #D00717;
          position: absolute;
        }
      }
    }
  }
  .about-box-03{
    padding-top:146px;
    position: relative;
    .titleBox {
      .subtitle{
        .line{
          width: 164px;
        }
        .subtitle-font{
          color: #3B240F;
          font-size: 40px;
          letter-spacing: 3.33px;
          padding-left: 25px;
        }
      }
    }
    .left{
      display: inline-block;
      .titleBox{
        margin-bottom: 45px;
      }
      .description{
        min-height: 372px;
        max-width: 568px;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
        padding:70px 185px 78px 58px;
        overflow: auto;
        margin-left: 33px;
        &::-webkit-scrollbar {
          width: 1px;
          height: 1px;
        }
        p{
          color: #000000;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }
      }
    }
    .right{
      display: inline-block;
      position: absolute;
      left: 450px;
      top: 180px;
      width: calc(100% - 437px);
      .img{
        max-width:970px;
        height: 424px;
        img{
          width: 100%;
          height: 100%;
          background-size: 100%;
        }
      }
    }
  }


</style>




// WEBPACK FOOTER //
// src/components/investor.vue